import { useState, useRef, useEffect, Fragment } from "react"

const PXLG_STATUS_STYLES = {
  running: { bg:"#dcfce7", color:"#16a34a", label:"Đang chạy" },
  stopped: { bg:"#fee2e2", color:"#dc2626", label:"Dừng"      },
  open:    { bg:"#dbeafe", color:"#2563eb", label:"Mở"        },
  ok:      { bg:"#f1f5f9", color:"#64748b", label:"OK"        },
}

// ─── PXLT — Dây chuyền Luyện Thép ────────────────────────

const PXLT_DATA = [
  // Lò điện hồ quang (EAF)
  { id:"LT.EAF.LDQ1",  name:"Lò điện hồ quang 30 tấn số 1",         type:"Lò",          qty:1, since:"03/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.EAF.LDQ2",  name:"Lò điện hồ quang 30 tấn số 2",         type:"Lò",          qty:1, since:"03/2016", status:"stopped", alarm:false, lastSeen:"12/03/2026 06:30" },
  { id:"LT.EAF.MBA1",  name:"Máy biến áp lò điện 1 (25 MVA)",        type:"Điện",        qty:1, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.EAF.MBA2",  name:"Máy biến áp lò điện 2 (25 MVA)",        type:"Điện",        qty:1, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.EAF.HE1",   name:"Hệ thống điện cực graphite lò 1",       type:"Điện",        qty:3, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.EAF.HE2",   name:"Hệ thống điện cực graphite lò 2",       type:"Điện",        qty:3, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.EAF.XITT",  name:"Xi tháo thép lò điện",                  type:"Khác",        qty:2, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.EAF.XIXI",  name:"Xi tháo xỉ lò điện",                    type:"Khác",        qty:2, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  // Lò tinh luyện (LF)
  { id:"LT.LF.LTL",    name:"Lò tinh luyện thép (Ladle Furnace 30T)", type:"Lò",          qty:1, since:"03/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.LF.MBA",    name:"Máy biến áp lò tinh luyện (6 MVA)",      type:"Điện",        qty:1, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.LF.HEC",    name:"Điện cực lò tinh luyện",                  type:"Điện",        qty:3, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.LF.BSUC",   name:"Bơm sục khí argon đáy thùng",            type:"Bơm",         qty:2, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.LF.HBR",    name:"Hệ thống bơm rót thép thùng gang",       type:"Bơm",         qty:1, since:"03/2016", status:"ok",      alarm:true,  lastSeen:"12/03/2026 07:15" },
  // Đúc liên tục (CCM)
  { id:"LT.CCM.DCL",   name:"Máy đúc liên tục 3 dòng (billet 150×150)",type:"Máy",        qty:1, since:"06/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.CCM.CTH",   name:"Cốc thu hồi nước làm mát đúc",           type:"Khác",        qty:1, since:"06/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.CCM.BNCM",  name:"Bơm nước cấp sơ cấp CCM",                type:"Bơm",         qty:3, since:"06/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.CCM.BNTC",  name:"Bơm nước tuần hoàn thứ cấp CCM",         type:"Bơm",         qty:3, since:"06/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.CCM.KCT",   name:"Kéo cắt thanh phôi tự động",             type:"Máy",         qty:3, since:"06/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.CCM.CTPH",  name:"Cần trục phôi thép 10 tấn",              type:"Thiết bị nâng",qty:1,since:"06/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  // Lọc bụi & khí thải
  { id:"LT.LD.LBLD1",  name:"Lọc bụi lò điện hồ quang số 1",         type:"Khác",        qty:1, since:"03/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.LD.LBLD2",  name:"Lọc bụi lò điện hồ quang số 2",         type:"Khác",        qty:1, since:"03/2016", status:"stopped", alarm:false, lastSeen:"12/03/2026 06:30" },
  { id:"LT.LD.LBLF",   name:"Lọc bụi lò tinh luyện",                  type:"Khác",        qty:1, since:"03/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.LD.QGK",    name:"Quạt gió khí thải chính",                 type:"Máy",         qty:2, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  // Tiếp liệu thép phế
  { id:"LT.TL.CTPH",   name:"Cầu trục phế liệu 16 tấn",               type:"Thiết bị nâng",qty:2,since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.TL.BVT",    name:"Bàn xe thùng thép / chở thùng luyện",    type:"Khác",        qty:2, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.TL.HXT",    name:"Hệ thống xe tải thùng luyện",             type:"Khác",        qty:2, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  // Hệ thống điện & điều khiển
  { id:"LT.DK.TDH",    name:"Tủ điều hành trung tâm luyện thép",      type:"Điện",        qty:1, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.DK.PLC1",   name:"PLC điều khiển lò điện 1",                type:"Điện",        qty:1, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.DK.PLC2",   name:"PLC điều khiển lò điện 2",                type:"Điện",        qty:1, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.DK.PLCLF",  name:"PLC điều khiển lò tinh luyện",            type:"Điện",        qty:1, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.DK.PLCCC",  name:"PLC điều khiển máy đúc liên tục",         type:"Điện",        qty:1, since:"06/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.DK.04KV",   name:"Hệ thống điện 0,4kV luyện thép",          type:"Điện",        qty:1, since:"03/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LT.DK.SCADA",  name:"Hệ thống SCADA luyện thép",               type:"Điện",        qty:1, since:"03/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
]

// ─── Lò Chuyển Thổi Luyện (BOF) ──────────────────────────

const BOF_HOPPERS = [
  { id:"1#", actual:267, setpt:200, mode:"remote", running:true,  alarm:false, color:"#2563eb" },
  { id:"2#", actual:251, setpt:200, mode:"remote", running:true,  alarm:false, color:"#2563eb" },
  { id:"3#", actual:765, setpt:700, mode:"remote", running:true,  alarm:false, color:"#f59e0b" },
  { id:"4#", actual:861, setpt:750, mode:"remote", running:true,  alarm:false, color:"#ef4444" },
  { id:"5#", actual:247, setpt:200, mode:"remote", running:false, alarm:false, color:"#2563eb" },
  { id:"6#", actual:381, setpt:200, mode:"manual", running:false, alarm:false, color:"#64748b" },
]

const BOF_COLLECTORS = [
  { id:"1#汇斗", label:"Phễu thu 1", valves:["1F01","1F02","1F03"], active:true  },
  { id:"2#汇斗", label:"Phễu thu 2", valves:["1F04","1F05","1F06"], active:false },
]

const BOF_FEEDS = [
  { id:"1F01", open:true  }, { id:"1F02", open:true  }, { id:"1F03", open:false },
  { id:"1F04", open:false }, { id:"1F05", open:false }, { id:"1F06", open:false },
]

const BOF_BATCH = [
  { id:"1#合", kg:0 }, { id:"2#合", kg:0 }, { id:"3#合", kg:0 },
  { id:"4#合", kg:0 }, { id:"5#合", kg:0 },
]

// ── Hopper SVG — trapezoid bunker with fill level ──
function HopperSVG({ actual=200, setpt=200, running=true, alarm=false, w=56, h=72, color="#2563eb" }) {
  const pct    = Math.min(actual / Math.max(setpt*1.5, actual), 1)
  const fillH  = pct * 38
  const over   = actual > setpt
  const fc     = alarm ? "#ef4444" : over ? "#f97316" : color
  const cx     = w / 2
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block"}}>
      {/* Inlet nozzle */}
      <rect x={cx-5} y={0} width={10} height={8} rx={2}
        fill={running ? "#94a3b8" : "#e2e8f0"}/>
      {/* Body trapezoid */}
      <polygon points={`4,8 ${w-4},8 ${w-10},50 ${10},50`}
        fill="white" stroke={alarm?"#fca5a5":"#e2e8f0"} strokeWidth={1.5}/>
      {/* Fill */}
      <clipPath id={`bofclip-${w}-${actual}`}>
        <polygon points={`5,8 ${w-5},8 ${w-10},50 ${10},50`}/>
      </clipPath>
      <rect x={5} y={8+(38-fillH)} width={w-10} height={fillH}
        fill={fc} opacity={0.25}
        clipPath={`url(#bofclip-${w}-${actual})`}/>
      {/* Setpoint line */}
      <line x1={8} y1={8+(38*(1-setpt/Math.max(setpt*1.5,actual)))}
            x2={w-8} y2={8+(38*(1-setpt/Math.max(setpt*1.5,actual)))}
        stroke={fc} strokeWidth={1} strokeDasharray="3 2" opacity={0.7}/>
      {/* Outlet cone */}
      <polygon points={`10,50 ${w-10},50 ${cx+3},64 ${cx-3},64`}
        fill={running?"#f1f5f9":"#f8fafc"} stroke="#e2e8f0" strokeWidth={1}/>
      {/* Valve nub */}
      <rect x={cx-4} y={62} width={8} height={8} rx={2}
        fill={running?"#22c55e":"#e2e8f0"}/>
      {/* Actual value */}
      <text x={cx} y={32} textAnchor="middle" fontSize={9} fontWeight="800"
        fill={over?"#ef4444":"#0f172a"}>{actual}</text>
      {/* Alarm dot */}
      {alarm && <circle cx={w-5} cy={12} r={4} fill="#ef4444" stroke="white" strokeWidth={1}/>}
    </svg>
  )
}

// ── Steam drum SVG ──
function SteamDrumSVG({ pressure=0.12, level=355, running=true, w=120, h=80 }) {
  const lh = Math.min(level/600, 1) * (h-20)
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block"}}>
      {/* Drum body */}
      <ellipse cx={w/2} cy={h/2} rx={w/2-3} ry={h/2-5}
        fill="white" stroke="#94a3b8" strokeWidth={2}/>
      {/* Water fill */}
      <clipPath id="drumclip">
        <ellipse cx={w/2} cy={h/2} rx={w/2-4} ry={h/2-6}/>
      </clipPath>
      <rect x={4} y={h/2-lh/2} width={w-8} height={lh}
        fill="#bfdbfe" opacity={0.6} clipPath="url(#drumclip)"/>
      {/* Steam zone */}
      <rect x={4} y={5} width={w-8} height={h/2-lh/2-1}
        fill="#e0f2fe" opacity={0.4} clipPath="url(#drumclip)"/>
      {/* Center label */}
      <text x={w/2} y={h/2-4} textAnchor="middle"
        fontSize={8} fontWeight="700" fill="#1e3a5f">Bình Hoa Hơi</text>
      <text x={w/2} y={h/2+8} textAnchor="middle"
        fontSize={8} fill="#64748b">{pressure} MPa</text>
      {/* Pipe nozzles */}
      <rect x={0} y={h/2-4} width={6} height={8} rx={2} fill="#94a3b8"/>
      <rect x={w-6} y={h/2-4} width={6} height={8} rx={2} fill="#94a3b8"/>
      <rect x={w/2-4} y={0} width={8} height={6} rx={2} fill="#94a3b8"/>
      <rect x={w/2-4} y={h-6} width={8} height={6} rx={2} fill="#94a3b8"/>
    </svg>
  )
}

// ── Oxygen lance SVG ──
function OxygenLanceSVG({ level=6.54, lanceDown=true, blowing=true, w=60, h=160 }) {
  const cx = w/2
  const tipY = lanceDown ? h*0.65 : h*0.15
  const fc   = blowing ? "#ef4444" : "#94a3b8"
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block"}}>
      {/* Furnace shell */}
      <ellipse cx={cx} cy={h*0.35} rx={22} ry={8}
        fill="#f1f5f9" stroke="#94a3b8" strokeWidth={1.5}/>
      <rect x={cx-22} y={h*0.35} width={44} height={h*0.45}
        fill="#f8fafc" stroke="#94a3b8" strokeWidth={1.5}/>
      <ellipse cx={cx} cy={h*0.8} rx={22} ry={8}
        fill="#f1f5f9" stroke="#94a3b8" strokeWidth={1.5}/>
      {/* Molten steel */}
      <rect x={cx-20} y={h*0.65} width={40} height={h*0.13}
        fill="#fde68a" opacity={0.8}/>
      {/* Lance */}
      <rect x={cx-3} y={0} width={6} height={tipY}
        fill={fc} opacity={0.8} rx={2}/>
      <polygon points={`${cx-6},${tipY} ${cx+6},${tipY} ${cx},${tipY+10}`}
        fill={fc}/>
      {/* Oxygen jet sparks */}
      {blowing && lanceDown && [[-6,tipY+12],[0,tipY+18],[6,tipY+12]].map(([dx,y],i)=>(
        <line key={i} x1={cx} y1={tipY+4} x2={cx+dx} y2={y}
          stroke="#f97316" strokeWidth={1.5} opacity={0.8}/>
      ))}
      {/* Level indicator */}
      <text x={cx} y={h*0.56} textAnchor="middle"
        fontSize={9} fontWeight="800" fill="#374151">{level} m</text>
    </svg>
  )
}

function LoCaoBOFView() {
  const [hoppers,    setHoppers]    = useState(BOF_HOPPERS)
  const [feeds,      setFeeds]      = useState(BOF_FEEDS)
  const [selHopper,  setSelHopper]  = useState(null)
  const [hovId,      setHovId]      = useState(null)
  const [blowing,    setBlowing]    = useState(true)
  const [lanceDown,  setLanceDown]  = useState(true)
  const [n2Timer,    setN2Timer]    = useState(107) // seconds
  const [o2Timer,    setO2Timer]    = useState(0)
  const [tapTimer,   setTapTimer]   = useState(0)
  const [n2SetPt,    setN2SetPt]    = useState(8.30)
  const [activeNav,  setActiveNav]  = useState("loc-bui")

  // Live pressure / level readings
  const SENSORS = {
    netWater:   { label:"Áp suất nước sạch",     val:"0.5",   unit:"MPa" },
    circWater:  { label:"Áp suất nước tuần hoàn", val:"0.803", unit:"MPa" },
    pt303:      { label:"PT303 — Áp suất hơi",    val:"0.00",  unit:"MPa" },
    pt1105:     { label:"PT1105 — Drum",           val:"0.12",  unit:"MPa" },
    lt05:       { label:"LT05 — Mức nước",         val:"347",   unit:"mm"  },
    lt06:       { label:"LT06 — Mức nước",         val:"363",   unit:"mm"  },
    pv1201:     { label:"PV1201 — Van chính",      val:"5.00",  unit:"%"   },
    ft1204:     { label:"FT1204 — Lưu lượng",      val:"80",    unit:"T/h" },
    supply:     { label:"Áp suất cấp nước",        val:"0.03",  unit:"MPa" },
  }

  const N2_PARAMS = {
    setPt:  { label:"Áp lực cài đặt", val:n2SetPt, unit:"kg" },
    actual: { label:"Áp lực thực tế", val:"16.45",  unit:"kg" },
    valve:  { label:"Độ mở van",      val:"25.0",   unit:"%"  },
    mode:   { label:"Chế độ",         val:"Tự động",unit:""   },
  }

  const alarmCount  = hoppers.filter(h=>h.alarm).length
  const runCount    = hoppers.filter(h=>h.running).length
  const overCount   = hoppers.filter(h=>h.actual>h.setpt).length

  const formatTime = (s) => `${Math.floor(s/60).toString().padStart(2,"0")}:${(s%60).toString().padStart(2,"0")} s`

  // ── Shared helpers (exact same as all other views) ──
  const HPipe = ({color="#22c55e",active=true,width=28,flow=null,unit="",vertical=false}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{
        width:vertical?3:width, height:vertical?width:3,
        background:active?color:"#e2e8f0",borderRadius:2,opacity:active?1:0.5,
        boxShadow:active?`0 0 4px ${color}66`:"none",transition:"all .2s"
      }}/>
      {flow!=null&&<span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600,whiteSpace:"nowrap"}}>
        {flow>0?`+${flow}`:flow} {unit}
      </span>}
    </div>
  )
  const Arrow = ({color="#22c55e",active=true,dir="right"}) => (
    <span style={{fontSize:10,color:active?color:"#e2e8f0",flexShrink:0,lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"}}>
      {dir==="right"?"▶":dir==="down"?"▼":"◀"}
    </span>
  )
  const ColHeader = ({title,count=null,extra=null}) => (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10}}>
      <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
        {title}{count!=null&&<span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}> ({count})</span>}
      </span>
      {extra}
    </div>
  )

  // ── Valve toggle mini SVG ──
  const ValveDot = ({open=true, size=16}) => (
    <svg viewBox={`0 0 ${size} ${size}`} style={{width:size,height:size,flexShrink:0}}>
      <circle cx={size/2} cy={size/2} r={size/2-1}
        fill="white" stroke={open?"#22c55e":"#ef4444"} strokeWidth={1.5}/>
      {open
        ? <ellipse cx={size/2} cy={size/2} rx={3} ry={6} fill="#22c55e" opacity={0.8}/>
        : <line x1={3} y1={size/2} x2={size-3} y2={size/2}
            stroke="#ef4444" strokeWidth={2}/>}
    </svg>
  )

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>

      {/* ── Main scrollable canvas ── */}
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

        {/* KPI strip */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"Áp suất nước sạch",     value:"0.5 MPa",   icon:"💧", color:"#0ea5e9"},
            {label:"Áp suất nước TH",        value:"0.803 MPa", icon:"🔄", color:"#2563eb"},
            {label:"Trạng thái thổi",        value:blowing?"Đang thổi":"Dừng",
              icon:"💨", color:blowing?"#ef4444":"#94a3b8"},
            {label:"Lò đang chạy",           value:`${runCount}/${hoppers.length}`,
              icon:"⚙", color:"#22c55e"},
            {label:"Vượt ngưỡng",            value:`${overCount}`, icon:"⚠",
              color:overCount>0?"#f97316":"#22c55e"},
            {label:"Cảnh báo",               value:`${alarmCount}`, icon:"🚨",
              color:alarmCount>0?"#ef4444":"#22c55e"},
          ].map(k=>(
            <div key={k.label} style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,
              flex:1,minWidth:90,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:14,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* 3-column layout */}
        <div style={{display:"flex",gap:0,minWidth:640}}>

          {/* ── COL 1: Steam drum + sensors + valves ── */}
          <div style={{width:210,borderRight:"1px solid #e2e8f0",paddingRight:12,flexShrink:0}}>

            <ColHeader title="Bình hoa hơi"/>

            {/* Steam drum card */}
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px",marginBottom:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)",
              display:"flex",flexDirection:"column",alignItems:"center",gap:6
            }}>
              <SteamDrumSVG pressure={0.12} level={355} running={true} w={110} h={70}/>
              {/* Level badges */}
              <div style={{display:"flex",gap:6,width:"100%"}}>
                {[{id:"LT05",val:"347"},{id:"LT06",val:"363"}].map(lt=>(
                  <div key={lt.id} style={{
                    flex:1,background:"#f8fafc",border:"1px solid #e2e8f0",
                    borderRadius:6,padding:"4px 6px",textAlign:"center"
                  }}>
                    <div style={{fontSize:8,color:"#94a3b8"}}>{lt.id}</div>
                    <div style={{fontSize:13,fontWeight:900,color:"#2563eb",fontFamily:"monospace"}}>{lt.val}</div>
                    <div style={{fontSize:7,color:"#94a3b8"}}>mm</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Sensor params card */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 10px",marginBottom:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:9,fontWeight:700,color:"#64748b",letterSpacing:1,
                textTransform:"uppercase",marginBottom:6}}>Cảm biến</div>
              {[
                {k:"PT303",   v:"0.00",  u:"MPa", c:"#2563eb"},
                {k:"PT1105",  v:"0.12",  u:"MPa", c:"#2563eb"},
                {k:"PV1201",  v:"5.00",  u:"%",   c:"#f59e0b"},
                {k:"FT1204",  v:"80",    u:"T/h", c:"#22c55e"},
                {k:"Cấp nước",v:"0.03",  u:"MPa", c:"#0ea5e9"},
              ].map(r=>(
                <div key={r.k} style={{
                  display:"flex",justifyContent:"space-between",alignItems:"center",
                  padding:"4px 0",borderBottom:"1px solid #f8fafc"
                }}>
                  <span style={{fontSize:9,color:"#64748b"}}>{r.k}</span>
                  <div style={{display:"flex",alignItems:"baseline",gap:2}}>
                    <span style={{fontSize:12,fontWeight:800,fontFamily:"monospace",color:r.c}}>{r.v}</span>
                    <span style={{fontSize:8,color:"#94a3b8"}}>{r.u}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Valve group card */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 10px",
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:9,fontWeight:700,color:"#64748b",letterSpacing:1,
                textTransform:"uppercase",marginBottom:6}}>Van điều khiển</div>
              {["M251","M252","M253","M254"].map((v,i)=>(
                <div key={v} style={{
                  display:"flex",alignItems:"center",justifyContent:"space-between",
                  padding:"4px 0",borderBottom:"1px solid #f8fafc"
                }}>
                  <span style={{fontSize:9,fontWeight:600,color:"#374151"}}>{v}</span>
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    <ValveDot open={i<2} size={14}/>
                    <span style={{fontSize:9,fontWeight:600,
                      color:i<2?"#16a34a":"#dc2626"}}>{i<2?"Mở":"Đóng"}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── COL 2: 6 hoppers + feed valves ── */}
          <div style={{flex:1,padding:"0 12px",minWidth:260}}>

            <ColHeader title="Phễu liệu" count={6}
              extra={
                <div style={{display:"flex",gap:4}}>
                  <button style={{padding:"3px 8px",border:"none",borderRadius:5,cursor:"pointer",
                    fontSize:9,fontWeight:600,background:"#f1f5f9",color:"#64748b"}}>Tất cả chạy</button>
                  <button style={{padding:"3px 8px",border:"none",borderRadius:5,cursor:"pointer",
                    fontSize:9,fontWeight:600,background:"#fee2e2",color:"#dc2626"}}>Dừng tất cả</button>
                </div>
              }/>

            {/* Top manifold pipe */}
            <div style={{height:4,
              background:"linear-gradient(90deg,#2563eb44,#0ea5e944)",
              borderRadius:2,marginBottom:8}}/>

            {/* Hopper grid 2×3 */}
            {[[0,1,2],[3,4,5]].map((row,ri)=>(
              <div key={ri} style={{display:"flex",gap:6,marginBottom:10}}>
                {row.map(idx=>{
                  const h = hoppers[idx]
                  const isSel = selHopper?.id===h.id
                  const isHov = hovId===`h-${h.id}`
                  const over  = h.actual > h.setpt
                  return (
                    <div key={h.id}
                      onClick={()=>setSelHopper(p=>p?.id===h.id?null:h)}
                      onMouseEnter={()=>setHovId(`h-${h.id}`)}
                      onMouseLeave={()=>setHovId(null)}
                      style={{
                        flex:1,background:isSel?"#eff6ff":over?"#fff7ed":"white",
                        border:`2px solid ${isSel?"#2563eb":over?"#fca5a5":h.running?"#e2e8f0":"#f1f5f9"}`,
                        borderRadius:8,padding:"8px 6px",cursor:"pointer",
                        textAlign:"center",transition:"all .15s",
                        boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":
                          isHov?"0 2px 8px rgba(0,0,0,0.08)":"0 1px 3px rgba(0,0,0,0.04)",
                        opacity:h.running?1:0.65
                      }}>
                      {/* Label */}
                      <div style={{fontSize:11,fontWeight:800,
                        color:isSel?"#2563eb":over?"#ef4444":"#374151",
                        marginBottom:3}}>{h.id}</div>
                      {/* Hopper SVG */}
                      <HopperSVG actual={h.actual} setpt={h.setpt}
                        running={h.running} alarm={h.alarm} color={h.color} w={48} h={62}/>
                      {/* Actual / setpt */}
                      <div style={{marginTop:4}}>
                        <div style={{
                          fontSize:10,fontWeight:900,fontFamily:"monospace",
                          color:over?"#ef4444":"#0f172a",lineHeight:1
                        }}>{h.actual}</div>
                        <div style={{fontSize:8,color:"#94a3b8"}}>
                          / {h.setpt} kg
                        </div>
                      </div>
                      {/* Mode + run chips */}
                      <div style={{display:"flex",gap:2,marginTop:4,justifyContent:"center"}}>
                        <span style={{
                          fontSize:7,fontWeight:700,padding:"1px 4px",borderRadius:4,
                          background:h.mode==="remote"?"#dbeafe":"#f1f5f9",
                          color:h.mode==="remote"?"#1d4ed8":"#64748b"
                        }}>{h.mode==="remote"?"Từ xa":"Thủ công"}</span>
                        <span style={{
                          fontSize:7,fontWeight:700,padding:"1px 4px",borderRadius:4,
                          background:h.running?"#dcfce7":"#fee2e2",
                          color:h.running?"#16a34a":"#dc2626"
                        }}>{h.running?"Chạy":"Dừng"}</span>
                      </div>
                    </div>
                  )
                })}
              </div>
            ))}

            {/* Bottom manifold */}
            <div style={{height:4,
              background:"linear-gradient(90deg,#22c55e44,#22c55e22)",
              borderRadius:2,marginBottom:10}}/>

            {/* Feed valve matrix */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>
                Van cấp liệu · Điều khiển thủ công
              </div>
              {[BOF_FEEDS.slice(0,3), BOF_FEEDS.slice(3,6)].map((row,ri)=>(
                <div key={ri} style={{display:"flex",gap:6,marginBottom:ri===0?6:0}}>
                  {row.map(f=>(
                    <div key={f.id}
                      onClick={()=>{
                        setFeeds(prev=>prev.map(pf=>pf.id===f.id?{...pf,open:!pf.open}:pf))
                      }}
                      style={{
                        flex:1,background:f.open?"#f0fdf4":"#fff5f5",
                        border:`1px solid ${f.open?"#bbf7d0":"#fecaca"}`,
                        borderRadius:6,padding:"5px 4px",cursor:"pointer",
                        textAlign:"center",transition:"all .15s"
                      }}>
                      <div style={{fontSize:8,fontWeight:700,color:"#64748b"}}>{f.id}</div>
                      <ValveDot open={f.open} size={16}/>
                      <div style={{fontSize:8,fontWeight:700,marginTop:2,
                        color:f.open?"#16a34a":"#dc2626"}}>{f.open?"Mở":"Đóng"}</div>
                    </div>
                  ))}
                </div>
              ))}

              {/* Collector hoppers */}
              <div style={{display:"flex",gap:6,marginTop:8,paddingTop:8,
                borderTop:"1px solid #f1f5f9"}}>
                {BOF_COLLECTORS.map(col=>(
                  <div key={col.id} style={{
                    flex:1,background:col.active?"#f0fdf4":"#f8fafc",
                    border:"1px solid #e2e8f0",borderRadius:6,
                    padding:"5px 6px",textAlign:"center"
                  }}>
                    <div style={{fontSize:9,fontWeight:700,
                      color:col.active?"#16a34a":"#94a3b8"}}>{col.label}</div>
                    <div style={{fontSize:8,color:"#94a3b8"}}>{col.id}</div>
                    <span style={{
                      fontSize:8,fontWeight:700,marginTop:2,display:"inline-block",
                      background:col.active?"#dcfce7":"#f1f5f9",
                      color:col.active?"#16a34a":"#64748b",
                      padding:"1px 5px",borderRadius:6
                    }}>{col.active?"Đang tiếp nhận":"Dừng"}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ── COL 3: Oxygen lance + timers + N2 + cumulative ── */}
          <div style={{width:210,borderLeft:"1px solid #e2e8f0",paddingLeft:12,flexShrink:0}}>

            {/* Lance status card */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",marginBottom:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
                <div style={{fontSize:10,fontWeight:700,color:"#374151"}}>Ống thổi oxy</div>
                <span style={{
                  fontSize:9,fontWeight:700,padding:"2px 7px",borderRadius:8,
                  background:blowing?"#fee2e2":"#f1f5f9",
                  color:blowing?"#dc2626":"#64748b"
                }}>{blowing?"Đang thổi":"Dừng"}</span>
              </div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <OxygenLanceSVG level={6.54} lanceDown={lanceDown} blowing={blowing} w={52} h={130}/>
                <div style={{flex:1}}>
                  {/* Level indicator */}
                  <div style={{
                    background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:6,
                    padding:"6px",marginBottom:6,textAlign:"center"
                  }}>
                    <div style={{fontSize:20,fontWeight:900,color:"#1e3a5f",
                      fontFamily:"monospace",lineHeight:1}}>6.54</div>
                    <div style={{fontSize:9,color:"#94a3b8"}}>m — vị trí lance</div>
                  </div>
                  {/* Control buttons */}
                  <div style={{display:"flex",gap:4,marginBottom:6}}>
                    <button onClick={()=>setLanceDown(true)} style={{
                      flex:1,padding:"4px 0",border:"none",borderRadius:4,cursor:"pointer",
                      fontSize:9,fontWeight:700,
                      background:lanceDown?"#1e3a5f":"#f1f5f9",
                      color:lanceDown?"white":"#64748b"
                    }}>▼ Hạ</button>
                    <button onClick={()=>setLanceDown(false)} style={{
                      flex:1,padding:"4px 0",border:"none",borderRadius:4,cursor:"pointer",
                      fontSize:9,fontWeight:700,
                      background:!lanceDown?"#1e3a5f":"#f1f5f9",
                      color:!lanceDown?"white":"#64748b"
                    }}>▲ Nâng</button>
                  </div>
                  <button onClick={()=>setBlowing(p=>!p)} style={{
                    width:"100%",padding:"5px 0",border:"none",borderRadius:5,cursor:"pointer",
                    fontSize:10,fontWeight:700,
                    background:blowing?"#ef4444":"#22c55e",
                    color:"white"
                  }}>{blowing?"■ Dừng thổi":"▶ Bắt đầu thổi"}</button>
                </div>
              </div>
            </div>

            {/* Timers card */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",marginBottom:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>
                Bộ đếm thời gian
              </div>
              {[
                {k:"N₂ timer", val:n2Timer, c:"#2563eb", active:n2Timer>0},
                {k:"O₂ timer", val:o2Timer, c:"#ef4444", active:o2Timer>0},
                {k:"Thời gian ra thép", val:tapTimer, c:"#f59e0b", active:false},
              ].map(t=>(
                <div key={t.k} style={{
                  display:"flex",justifyContent:"space-between",alignItems:"center",
                  padding:"5px 0",borderBottom:"1px solid #f8fafc"
                }}>
                  <span style={{fontSize:9,color:"#64748b"}}>{t.k}</span>
                  <span style={{
                    fontSize:12,fontWeight:900,fontFamily:"monospace",
                    color:t.active?t.c:"#94a3b8",
                    background:t.active?`${t.c}11`:"transparent",
                    padding:t.active?"2px 6px":"2px 0",borderRadius:4
                  }}>{formatTime(t.val)}</span>
                </div>
              ))}
            </div>

            {/* N2 pressure settings */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",marginBottom:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
                <div style={{fontSize:10,fontWeight:700,color:"#374151"}}>Áp lực N₂</div>
                <span style={{fontSize:8,fontWeight:700,background:"#dcfce7",
                  color:"#16a34a",padding:"1px 6px",borderRadius:8}}>Tự động</span>
              </div>
              {[
                {k:"Cài đặt",  v:`${n2SetPt.toFixed(2)}`, u:"kg", c:"#2563eb"},
                {k:"Thực tế",  v:"16.45", u:"kg", c:"#ef4444"},
                {k:"Độ mở van",v:"25.0",  u:"%",  c:"#f59e0b"},
              ].map(r=>(
                <div key={r.k} style={{
                  display:"flex",justifyContent:"space-between",alignItems:"center",
                  padding:"4px 0",borderBottom:"1px solid #f8fafc"
                }}>
                  <span style={{fontSize:9,color:"#64748b"}}>{r.k}</span>
                  <div>
                    <span style={{fontSize:12,fontWeight:800,fontFamily:"monospace",color:r.c}}>{r.v}</span>
                    <span style={{fontSize:8,color:"#94a3b8",marginLeft:2}}>{r.u}</span>
                  </div>
                </div>
              ))}
              {/* Setpoint +/- */}
              <div style={{display:"flex",gap:4,marginTop:6}}>
                {["+0.5","-0.5"].map(s=>(
                  <button key={s} onClick={()=>setN2SetPt(p=>+(p+(s.startsWith("+")?0.5:-0.5)).toFixed(2))}
                    style={{
                      flex:1,padding:"3px 0",border:"1px solid #e2e8f0",
                      borderRadius:4,background:"white",fontSize:9,fontWeight:700,
                      color:s.startsWith("+")?"#16a34a":"#dc2626",cursor:"pointer"
                    }}>{s}</button>
                ))}
              </div>
            </div>

            {/* Cumulative batch */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>
                Tích lũy liệu nạp
              </div>
              {BOF_BATCH.map(b=>(
                <div key={b.id} style={{
                  display:"flex",justifyContent:"space-between",
                  padding:"3px 0",borderBottom:"1px solid #f8fafc"
                }}>
                  <span style={{fontSize:9,color:"#64748b"}}>{b.id}</span>
                  <span style={{fontSize:11,fontWeight:800,fontFamily:"monospace",
                    color:b.kg>0?"#0f172a":"#94a3b8"}}>{b.kg} kg</span>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>

      {/* ── Right detail panel 268px ── */}
      <div style={{
        width:268,background:"white",borderLeft:"1px solid #e2e8f0",
        flexShrink:0,overflowY:"auto"
      }}>
        {!selHopper ? (
          <div style={{height:"100%",display:"flex",flexDirection:"column",
            alignItems:"center",justifyContent:"center",
            color:"#94a3b8",padding:20,textAlign:"center",gap:8}}>
            <span style={{fontSize:32}}>🏭</span>
            <span style={{fontWeight:600,color:"#64748b",fontSize:12}}>Chọn phễu liệu</span>
            <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
              Nhấp vào một trong 6 phễu để xem chi tiết
            </span>
          </div>
        ) : (()=>{
          const h     = selHopper
          const over  = h.actual > h.setpt
          const pct   = Math.min(h.actual/Math.max(h.setpt*1.5,h.actual)*100,100)
          const trend = Array.from({length:18},(_,i)=>
            30+Math.abs(Math.sin(i/3))*50+(Math.random()-.5)*10
          )
          return (
            <div>
              <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
                display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div>
                  <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>Phễu {h.id} · </span>
                  <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>Bunker {h.id}</span>
                </div>
                {over&&<span style={{width:18,height:18,borderRadius:"50%",background:"#f97316",
                  display:"inline-flex",alignItems:"center",justifyContent:"center",
                  fontSize:9,color:"white",fontWeight:900}}>!</span>}
              </div>
              <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
                {["Thông tin","Lịch sử"].map((t,i)=>(
                  <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
                    fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
                    borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",
                    background:"none"}}>{t}</button>
                ))}
              </div>
              {/* Hopper preview + value */}
              <div style={{padding:"14px",display:"flex",gap:12,alignItems:"center",
                background:"white",borderBottom:"1px solid #f1f5f9"}}>
                <HopperSVG actual={h.actual} setpt={h.setpt} running={h.running}
                  alarm={h.alarm} color={h.color} w={54} h={76}/>
                <div style={{flex:1}}>
                  <div style={{fontSize:22,fontWeight:800,
                    color:over?"#ef4444":"#0f172a",lineHeight:1,fontFamily:"monospace"}}>
                    {h.actual}
                    <span style={{fontSize:11,fontWeight:400,color:"#94a3b8",marginLeft:2}}>kg</span>
                  </div>
                  <div style={{fontSize:10,color:"#64748b",marginTop:3}}>
                    Cài đặt: {h.setpt} kg
                  </div>
                  {/* Progress bar */}
                  <div style={{height:5,background:"#f1f5f9",borderRadius:3,
                    overflow:"hidden",marginTop:6}}>
                    <div style={{height:"100%",width:`${pct}%`,borderRadius:3,
                      background:over?"#ef4444":pct>80?"#f59e0b":"#22c55e",
                      transition:"width .3s"}}/>
                  </div>
                  <div style={{marginTop:6,display:"inline-flex",alignItems:"center",gap:4,
                    background:h.running?"#dcfce7":"#fee2e2",
                    color:h.running?"#16a34a":"#dc2626",
                    padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:600}}>
                    {h.running?"⚙ Đang chạy":"■ Dừng"}
                  </div>
                </div>
              </div>
              {/* Fields */}
              {[
                ["Mã phễu",    h.id],
                ["Thực tế",    `${h.actual} kg`],
                ["Cài đặt",    `${h.setpt} kg`],
                ["Sai lệch",   `${h.actual-h.setpt > 0?"+":""}${h.actual-h.setpt} kg`],
                ["Chế độ",     h.mode==="remote"?"Từ xa":"Thủ công"],
                ["Trạng thái", h.running?"Đang chạy":"Dừng"],
              ].map(([k,v])=>(
                <div key={k} style={{display:"flex",justifyContent:"space-between",
                  padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
                  <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
                  <span style={{fontSize:11,fontWeight:600,
                    color:k==="Sai lệch"&&h.actual>h.setpt?"#ef4444":
                      k==="Trạng thái"&&!h.running?"#dc2626":"#0f172a"}}>{v}</span>
                </div>
              ))}
              {/* Trend */}
              <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
                color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>GIỜ VỪA QUA</div>
              <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
                <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
                  {trend.map((v,i)=>(
                    <div key={i} style={{flex:1,height:`${v}%`,
                      background:over?"#ef4444":h.color,
                      borderRadius:"1px 1px 0 0",opacity:0.8}}/>
                  ))}
                </div>
                <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
                  <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
                  <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
                </div>
              </div>
            </div>
          )
        })()}
      </div>
    </div>
  )
}


// ─── Vận Hành Lò Chuyển ────────────────────────────────────

// ── Converter cross-section SVG — white bg, clean strokes (charte) ──
function ConverterSVG({ blowing=true, temp=1634, lancePos=6.64, w=120, h=150 }) {
  const cx = w/2
  const lanceH = Math.min(lancePos/10, 0.7)*h*0.55 + h*0.04
  const c = "#1e3a5f"
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block"}}>
      <path d={`M ${cx-20},${h*0.06} L ${cx+20},${h*0.06}
        L ${cx+32},${h*0.20} L ${cx+34},${h*0.62}
        L ${cx+24},${h*0.82} L ${cx-24},${h*0.82}
        L ${cx-34},${h*0.62} L ${cx-32},${h*0.20} Z`}
        fill="white" stroke={c} strokeWidth={1.5}/>
      <path d={`M ${cx-13},${h*0.08} L ${cx+13},${h*0.08}
        L ${cx+24},${h*0.22} L ${cx+26},${h*0.60}
        L ${cx+18},${h*0.78} L ${cx-18},${h*0.78}
        L ${cx-26},${h*0.60} L ${cx-24},${h*0.22} Z`}
        fill={blowing?"#fef2f2":"#f8fafc"} stroke={blowing?"#fca5a5":"#e2e8f0"} strokeWidth={1}/>
      <ellipse cx={cx} cy={h*0.70} rx={15} ry={7}
        fill={blowing?"#f97316":"#cbd5e1"} opacity={0.9}/>
      {blowing && <>
        <ellipse cx={cx} cy={h*0.62} rx={9}  ry={5} fill="#fbbf24" opacity={0.6}/>
        <ellipse cx={cx} cy={h*0.55} rx={5}  ry={3} fill="white"   opacity={0.5}/>
      </>}
      <rect x={0}   y={h*0.40} width={7} height={11} rx={2} fill="#94a3b8"/>
      <rect x={w-7} y={h*0.40} width={7} height={11} rx={2} fill="#94a3b8"/>
      <rect x={cx-5} y={h*0.80} width={10} height={4} rx={1}
        fill={blowing?"#f97316":"#94a3b8"}/>
      <rect x={cx-2.5} y={0} width={5} height={lanceH}
        fill={blowing?"#ef4444":"#94a3b8"} rx={1.5} opacity={0.9}/>
      {blowing && <>
        <ellipse cx={cx} cy={lanceH+4} rx={4} ry={3} fill="#fbbf24" opacity={0.85}/>
        <ellipse cx={cx} cy={lanceH+2} rx={2} ry={2} fill="white"   opacity={0.7}/>
      </>}
      <text x={cx} y={h-4} textAnchor="middle" fontSize={10} fontWeight="800"
        fill={blowing?"#ef4444":"#94a3b8"} fontFamily="monospace">
        {lancePos.toFixed(2)} m
      </text>
    </svg>
  )
}

// ── Instrument line data ──
const VH_O2_LINE = [
  { id:"TE3001", label:"TE3001", val:"46.0", unit:"°C",   color:"#f59e0b", isValve:false },
  { id:"PT3001", label:"PT3001", val:"16.5", unit:"kg",   color:"#2563eb", isValve:false },
  { id:"PV3001", label:"PV3001", val:"99",   unit:"%",    color:"#22c55e", isValve:true  },
  { id:"PT3005", label:"PT3005", val:"16.6", unit:"kg",   color:"#2563eb", isValve:false },
  { id:"FT3001", label:"FT3001", val:"222",  unit:"Nm³",  color:"#0ea5e9", isValve:false },
  { id:"FV3001", label:"FV3001", val:"65",   unit:"%",    color:"#22c55e", isValve:true  },
  { id:"PT3002", label:"PT3002", val:"16.4", unit:"kg",   color:"#2563eb", isValve:false },
]
const VH_N2_LINE = [
  { id:"TE3002", label:"TE3002", val:"44.0", unit:"°C",   color:"#f59e0b", isValve:false },
  { id:"PT3003", label:"PT3003", val:"17.72",unit:"kg",   color:"#2563eb", isValve:false },
  { id:"PV3063", label:"PV3063", val:"100",  unit:"%",    color:"#22c55e", isValve:true  },
  { id:"FT3003", label:"FT3003", val:"222",  unit:"Nm³",  color:"#0ea5e9", isValve:false },
  { id:"FV3063", label:"FV3063", val:"100",  unit:"%",    color:"#22c55e", isValve:true  },
  { id:"PT3004", label:"PT3004", val:"17.80",unit:"kg",   color:"#2563eb", isValve:false },
]
const VH_WATER_FLOWS = [
  { id:"WF01", label:"Inlet — bên trái",      val:"25.0", unit:"m³/h", color:"#0ea5e9", active:true  },
  { id:"WF02", label:"Inlet — bên phải",      val:"19.3", unit:"m³/h", color:"#0ea5e9", active:true  },
  { id:"WF03", label:"Inlet — miệng lò",      val:"18.6", unit:"m³/h", color:"#0ea5e9", active:true  },
  { id:"WF04", label:"Inlet — ống lance",     val:"20.1", unit:"m³/h", color:"#0ea5e9", active:true  },
  { id:"WF05", label:"Inlet — khung vải",     val:"6.8",  unit:"m³/h", color:"#0ea5e9", active:true  },
  { id:"WF06", label:"Outlet T° — bên trái",  val:"32.0", unit:"°C",   color:"#f59e0b", active:true  },
  { id:"WF07", label:"Outlet T° — bên phải",  val:"32.0", unit:"°C",   color:"#f59e0b", active:true  },
  { id:"WF08", label:"Outlet T° — miệng lò",  val:"37.0", unit:"°C",   color:"#ef4444", active:true  },
  { id:"WF09", label:"Outlet T° — ống lance", val:"32.0", unit:"°C",   color:"#f59e0b", active:true  },
  { id:"WF10", label:"Outlet T° — guigeon",   val:"32.0", unit:"°C",   color:"#f59e0b", active:true  },
  { id:"WF11", label:"Outlet Q — miệng lò",   val:"4.4",  unit:"m³/h", color:"#22c55e", active:true  },
]
const VH_OUTPUTS = [
  { id:"OUT-O2", label:"O₂ ra lò",   icon:"🔴", flow:73,   unit:"m³/h",  color:"#ef4444", active:true  },
  { id:"OUT-N2", label:"N₂ ra lò",   icon:"🔵", flow:71,   unit:"m³/h",  color:"#2563eb", active:true  },
  { id:"OUT-ST", label:"Thép lỏng",  icon:"🔥", flow:1634, unit:"°C",    color:"#f97316", active:true  },
  { id:"OUT-GS", label:"Khói lò",    icon:"🌫", flow:0,    unit:"Nm³/h", color:"#94a3b8", active:false },
]

function VanHanhLoChuYenView() {
  const [selItem,  setSelItem]  = useState(null)
  const [hovId,    setHovId]    = useState(null)
  const [blowing,  setBlowing]  = useState(true)
  const [lancePos, setLancePos] = useState(6.64)
  const [n2Timer]  = useState({m:1,s:47})
  const [o2Timer]  = useState({m:0,s:0})
  const alarmsN = 0

  const HPipe = ({color="#22c55e",active=true,flow=null,width=28,unit=""}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{width,height:3,background:active?color:"#e2e8f0",borderRadius:2,
        opacity:active?1:0.5,boxShadow:active?`0 0 4px ${color}66`:"none",transition:"all .2s"}}/>
      {flow!=null&&<span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600,whiteSpace:"nowrap"}}>
        {flow>0?`+${flow}`:flow} {unit}</span>}
    </div>
  )
  const Arrow = ({color="#22c55e",active=true,dir="right"}) => (
    <span style={{fontSize:10,color:active?color:"#e2e8f0",flexShrink:0,lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"}}>
      {dir==="right"?"▶":"◀"}</span>
  )
  const ColHeader = ({title,count=null,extra=null}) => (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
      <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
        {title}{count!=null&&<span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}> ({count})</span>}
      </span>
      {extra||<div/>}
    </div>
  )

  const InstrCard = ({item}) => {
    const isSel = selItem?.data?.id===item.id
    const isHov = hovId===item.id
    return (
      <div onClick={()=>setSelItem(isSel?null:{type:"instr",data:item})}
        onMouseEnter={()=>setHovId(item.id)} onMouseLeave={()=>setHovId(null)}
        style={{background:"white",border:`2px solid ${isSel?"#2563eb":"#e2e8f0"}`,
          borderRadius:8,padding:"8px 10px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s"}}>
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:5}}>
          <svg viewBox="0 0 22 22" style={{width:22,height:22,flexShrink:0}}>
            {item.isValve ? (
              <><circle cx={11} cy={11} r={9} fill="white" stroke={item.color} strokeWidth={1.5}/>
                <polygon points="3,11 11,5 11,17" fill={item.color} opacity={0.55}/>
                <polygon points="19,11 11,5 11,17" fill={item.color} opacity={0.55}/></>
            ) : (
              <><rect x={1} y={3} width={20} height={16} rx={3} fill="white" stroke={item.color} strokeWidth={1.5}/>
                <circle cx={11} cy={11} r={4} fill={item.color} opacity={0.2}/>
                <circle cx={11} cy={11} r={2} fill={item.color}/></>
            )}
          </svg>
          <div style={{flex:1}}>
            <div style={{fontSize:10,fontWeight:700,color:"#374151"}}>{item.label}</div>
            <div style={{fontSize:8,fontFamily:"monospace",color:"#94a3b8"}}>{item.isValve?"Van":"Cảm biến"}</div>
          </div>
          <span style={{fontSize:9,background:"#dcfce7",color:"#16a34a",padding:"1px 6px",borderRadius:8,fontWeight:600}}>OK</span>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:4}}>
          <div style={{width:12,height:3,background:item.color,borderRadius:2}}/>
          <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
            <rect x={1} y={2} width={12} height={14} rx={2} fill="white" stroke={item.color} strokeWidth={1.5}/>
            <circle cx={7} cy={9} r={3} fill={item.color} opacity={0.25}/>
            <circle cx={7} cy={9} r={1.5} fill={item.color}/>
            <line x1={13} y1={9} x2={18} y2={9} stroke={item.color} strokeWidth={1.5}/>
            <rect x={18} y={2} width={9} height={14} rx={2} fill="white" stroke={item.color} strokeWidth={1.5}/>
          </svg>
          <div style={{width:6,height:3,background:item.color,borderRadius:2}}/>
          <Arrow color={item.color} active={true} dir="right"/>
          <div style={{flex:1,textAlign:"right"}}>
            <span style={{fontSize:14,fontWeight:800,color:item.color,fontFamily:"monospace"}}>{item.val}</span>
            <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>{item.unit}</span>
          </div>
        </div>
      </div>
    )
  }

  const ConverterCard = () => {
    const isSel = selItem?.type==="converter"
    const isHov = hovId==="converter"
    return (
      <div onClick={()=>setSelItem(isSel?null:{type:"converter",data:{id:"BOF-01",label:"Lò chuyển BOF"}})}
        onMouseEnter={()=>setHovId("converter")} onMouseLeave={()=>setHovId(null)}
        style={{background:"white",border:`2px solid ${isSel?"#2563eb":blowing?"#fca5a5":"#e2e8f0"}`,
          borderRadius:8,padding:"12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s"}}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
          <div style={{width:34,height:34,borderRadius:6,background:blowing?"#fef2f2":"#f1f5f9",
            display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>
            {blowing?"🔥":"🏭"}
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>Lò chuyển BOF</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>BOF-01</div>
          </div>
          <span style={{fontSize:9,fontWeight:600,padding:"1px 6px",borderRadius:8,
            background:blowing?"#fee2e2":"#dcfce7",color:blowing?"#dc2626":"#16a34a"}}>
            {blowing?"Đang thổi":"Dừng"}</span>
        </div>
        <div style={{display:"flex",justifyContent:"center",marginBottom:10}}>
          <ConverterSVG blowing={blowing} temp={1634} lancePos={lancePos} w={120} h={150}/>
        </div>
        <div style={{display:"flex",gap:10,marginBottom:8}}>
          <div style={{flex:1}}>
            <div style={{fontSize:9,color:"#94a3b8",marginBottom:1}}>Vị trí lance</div>
            <div style={{fontSize:22,fontWeight:900,color:blowing?"#ef4444":"#94a3b8",lineHeight:1,fontFamily:"monospace"}}>
              {lancePos.toFixed(2)}<span style={{fontSize:9,fontWeight:400,color:"#94a3b8",marginLeft:2}}>m</span>
            </div>
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:9,color:"#94a3b8",marginBottom:1}}>Nhiệt độ</div>
            <div style={{fontSize:16,fontWeight:700,color:"#f97316",lineHeight:1,fontFamily:"monospace"}}>
              1634<span style={{fontSize:9,fontWeight:400,color:"#94a3b8",marginLeft:2}}>°C</span>
            </div>
          </div>
        </div>
        <div style={{height:5,background:"#f1f5f9",borderRadius:3,overflow:"hidden",marginBottom:8}}>
          <div style={{height:"100%",borderRadius:3,transition:"width .3s",
            width:blowing?"62%":"0%",background:blowing?"#ef4444":"#e2e8f0"}}/>
        </div>
        <div style={{display:"flex",gap:5}}>
          <button onClick={e=>{e.stopPropagation();setBlowing(true)}} style={{
            flex:1,padding:"4px 0",border:"none",borderRadius:5,cursor:"pointer",fontSize:10,
            fontWeight:600,background:blowing?"#22c55e":"#f1f5f9",color:blowing?"white":"#64748b"}}>▶ Thổi</button>
          <button onClick={e=>{e.stopPropagation();setBlowing(false)}} style={{
            flex:1,padding:"4px 0",border:"none",borderRadius:5,cursor:"pointer",fontSize:10,
            fontWeight:600,background:!blowing?"#ef4444":"#f1f5f9",color:!blowing?"white":"#64748b"}}>■ Dừng</button>
        </div>
      </div>
    )
  }

  const OutputCard = ({item}) => {
    const isSel = selItem?.data?.id===item.id
    const isHov = hovId===item.id
    return (
      <div onClick={()=>setSelItem(isSel?null:{type:"output",data:item})}
        onMouseEnter={()=>setHovId(item.id)} onMouseLeave={()=>setHovId(null)}
        style={{background:"white",border:`2px solid ${isSel?"#2563eb":item.active?"#e2e8f0":"#f1f5f9"}`,
          borderRadius:8,padding:"10px 12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:item.active?1:0.55}}>
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
          <span style={{fontSize:16}}>{item.icon}</span>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{item.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{item.id}</div>
          </div>
          {!item.active&&<span style={{fontSize:9,background:"#fee2e2",color:"#dc2626",padding:"1px 6px",borderRadius:8,fontWeight:600}}>Dừng</span>}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:4}}>
          <Arrow color={item.color} active={item.active} dir="left"/>
          <div style={{width:6,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
            <rect x={1} y={2} width={12} height={14} rx={2} fill="white" stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <circle cx={7} cy={9} r={3} fill={item.active?item.color:"#e2e8f0"} opacity={0.25}/>
            <circle cx={7} cy={9} r={1.5} fill={item.active?item.color:"#e2e8f0"}/>
            <line x1={13} y1={9} x2={18} y2={9} stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <rect x={18} y={2} width={9} height={14} rx={2} fill="white" stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
          </svg>
          <div style={{width:8,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <div style={{flex:1,textAlign:"right"}}>
            <span style={{fontSize:14,fontWeight:800,color:item.active?item.color:"#94a3b8",fontFamily:"monospace"}}>{item.flow}</span>
            <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>{item.unit}</span>
          </div>
        </div>
      </div>
    )
  }

  const WaterCard = ({item}) => {
    const isSel = selItem?.data?.id===item.id
    return (
      <div onClick={()=>setSelItem(isSel?null:{type:"water",data:item})}
        style={{background:"white",border:`2px solid ${isSel?"#2563eb":"#e2e8f0"}`,
          borderRadius:6,padding:"6px 8px",cursor:"pointer",
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":"none",transition:"all .15s"}}>
        <div style={{fontSize:9,color:"#94a3b8",marginBottom:3,lineHeight:1.2}}>{item.label}</div>
        <div style={{display:"flex",alignItems:"baseline",gap:3}}>
          <span style={{fontSize:15,fontWeight:900,color:item.color,fontFamily:"monospace"}}>{item.val}</span>
          <span style={{fontSize:8,color:"#94a3b8"}}>{item.unit}</span>
        </div>
      </div>
    )
  }

  const DetailPanel = () => {
    if (!selItem) return (
      <div style={{height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",
        color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8}}>
        <span style={{fontSize:32}}>⚙</span>
        <span style={{fontWeight:600,color:"#64748b"}}>Chọn phần tử</span>
        <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>Nhấp vào thiết bị đo, đầu ra hoặc làm mát</span>
      </div>
    )
    const item  = selItem.data
    const color = item.color||"#2563eb"
    const trend = Array.from({length:18},(_,i)=>30+Math.abs(Math.sin(i/3))*50+(Math.random()-.5)*8)
    const fields = selItem.type==="converter" ? [
      ["ID","BOF-01"],["Trạng thái",blowing?"Đang thổi":"Dừng"],
      ["Lance",`${lancePos.toFixed(2)} m`],["Nhiệt độ","1 634 °C"],
    ] : selItem.type==="output" ? [
      ["ID",item.id],["Lưu lượng",`${item.flow} ${item.unit}`],
      ["Trạng thái",item.active?"Hoạt động":"Dừng"],
    ] : [
      ["ID",item.id],["Giá trị",`${item.val} ${item.unit}`],
      ["Loại",item.isValve?"Van":"Cảm biến"],["Trạng thái","Hoạt động"],
    ]
    return (
      <div>
        <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
          display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{item.id} · </span>
            <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{item.label||item.id}</span>
          </div>
          <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
        </div>
        <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
          {["Thông tin","Lịch sử"].map((t,i)=>(
            <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
              fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
              borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",background:"none"}}>{t}</button>
          ))}
        </div>
        <div style={{padding:"14px",background:"white",borderBottom:"1px solid #f1f5f9",textAlign:"center"}}>
          <div style={{fontSize:28,fontWeight:900,fontFamily:"monospace",
            color:selItem.type==="converter"?blowing?"#ef4444":"#94a3b8":color,lineHeight:1}}>
            {selItem.type==="converter"?`${lancePos.toFixed(2)}`:selItem.type==="output"?item.flow:item.val}
          </div>
          <div style={{fontSize:10,color:"#94a3b8",marginTop:4}}>
            {selItem.type==="converter"?"m":selItem.type==="output"?item.unit:item.unit}
          </div>
        </div>
        {fields.map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
            <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
            <span style={{fontSize:11,fontWeight:600,color:"#0f172a"}}>{v}</span>
          </div>
        ))}
        <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>GIỜ VỪA QUA</div>
        <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
          <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
            {trend.map((v,i)=>(
              <div key={i} style={{flex:1,height:`${v}%`,background:color,borderRadius:"1px 1px 0 0",opacity:0.8}}/>
            ))}
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
            <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
            <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>
        {/* KPI strip */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"Lưu lượng O₂",  value:"73 m³/h",  icon:"🔴",color:"#ef4444"},
            {label:"Lưu lượng N₂",  value:"71 m³/h",  icon:"🔵",color:"#2563eb"},
            {label:"Áp lực O₂",     value:"16.55 kg", icon:"📊",color:"#ef4444"},
            {label:"Vị trí lance",  value:`${lancePos.toFixed(2)} m`,icon:"🔩",color:blowing?"#ef4444":"#94a3b8"},
            {label:"N₂ timer",      value:`${n2Timer.m}:${String(n2Timer.s).padStart(2,"0")} s`,icon:"⏱",color:"#2563eb"},
            {label:"Cảnh báo",      value:`${alarmsN}`,icon:"⚠",color:"#22c55e"},
          ].map(k=>(
            <div key={k.label} style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,
              flex:1,minWidth:100,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:15,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>
        {/* 3-column */}
        <div style={{display:"flex",gap:0,minWidth:600}}>
          {/* COL 1 */}
          <div style={{flex:1,borderRight:"1px solid #e2e8f0",paddingRight:12,minWidth:170}}>
            <ColHeader title="Đường ống O₂" count={VH_O2_LINE.length} extra={
              <div style={{display:"flex",alignItems:"center",gap:4}}>
                <HPipe color="#ef4444" active={true} width={20}/>
                <Arrow color="#ef4444" active={true} dir="right"/>
              </div>}/>
            {VH_O2_LINE.map(item=><InstrCard key={item.id} item={item}/>)}
            <div style={{marginTop:4}}>
              <ColHeader title="Đường ống N₂" count={VH_N2_LINE.length} extra={
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <HPipe color="#2563eb" active={true} width={20}/>
                  <Arrow color="#2563eb" active={true} dir="right"/>
                </div>}/>
              {VH_N2_LINE.map(item=><InstrCard key={item.id} item={item}/>)}
            </div>
          </div>
          {/* COL 2 */}
          <div style={{flex:1.1,borderRight:"1px solid #e2e8f0",padding:"0 12px",minWidth:180}}>
            <ColHeader title="Lò chuyển" count={1} extra={
              <div style={{display:"flex",gap:4}}>
                <button onClick={()=>setBlowing(true)} style={{padding:"3px 8px",border:"none",borderRadius:5,cursor:"pointer",fontSize:10,fontWeight:600,background:blowing?"#22c55e":"#f1f5f9",color:blowing?"white":"#64748b"}}>▶</button>
                <button onClick={()=>setBlowing(false)} style={{padding:"3px 8px",border:"none",borderRadius:5,cursor:"pointer",fontSize:10,fontWeight:600,background:!blowing?"#ef4444":"#f1f5f9",color:!blowing?"white":"#64748b"}}>■</button>
              </div>}/>
            <ConverterCard/>
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,padding:"10px 12px",marginBottom:8,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>Điều Chỉnh O₂</div>
              {[{k:"Pressure Setting",v:"8.30",u:"Kg",c:"#374151"},{k:"Pressure Process",v:"16.55",u:"Kg",c:"#ef4444"},{k:"Valve Opening",v:"65.0",u:"%",c:"#22c55e"},{k:"Flow Setting",v:"4 000",u:"m³/h",c:"#374151"},{k:"Flow Process",v:"0",u:"m³/h",c:"#2563eb"}].map(r=>(
                <div key={r.k} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"4px 0",borderBottom:"1px solid #f8fafc"}}>
                  <span style={{fontSize:9,color:"#94a3b8"}}>{r.k}</span>
                  <span style={{fontSize:13,fontWeight:800,color:r.c,fontFamily:"monospace"}}>{r.v}<span style={{fontSize:8,fontWeight:400,color:"#94a3b8",marginLeft:2}}>{r.u}</span></span>
                </div>
              ))}
            </div>
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,padding:"10px 12px",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>Thời Gian Thổi</div>
              {[{label:"O₂ timer",val:`${o2Timer.m}:${String(o2Timer.s).padStart(2,"0")}`,c:"#ef4444"},{label:"N₂ timer",val:`${n2Timer.m}:${String(n2Timer.s).padStart(2,"0")}`,c:"#2563eb"}].map(t=>(
                <div key={t.label} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:"1px solid #f8fafc"}}>
                  <span style={{fontSize:10,color:"#64748b"}}>{t.label}</span>
                  <span style={{fontSize:18,fontWeight:900,color:t.c,fontFamily:"monospace",background:"#f8fafc",border:`1px solid ${t.c}33`,borderRadius:5,padding:"2px 10px"}}>{t.val}</span>
                </div>
              ))}
            </div>
          </div>
          {/* COL 3 */}
          <div style={{flex:1,paddingLeft:12,minWidth:170}}>
            <div style={{display:"flex",alignItems:"center",marginBottom:12}}>
              <Arrow color="#ef4444" active={true} dir="left"/>
              <HPipe color="#ef4444" active={true} width={14}/>
              <div style={{flex:1}}><ColHeader title="Đầu ra" count={VH_OUTPUTS.length}/></div>
            </div>
            {VH_OUTPUTS.map(o=><OutputCard key={o.id} item={o}/>)}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,padding:"10px 12px",marginTop:4,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8,display:"flex",alignItems:"center",gap:6}}>
                Nước Làm Mát <HPipe color="#0ea5e9" active={true} width={20}/>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:4}}>
                {VH_WATER_FLOWS.map(f=><WaterCard key={f.id} item={f}/>)}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Detail panel */}
      <div style={{width:268,background:"white",borderLeft:"1px solid #e2e8f0",flexShrink:0,overflowY:"auto"}}>
        <DetailPanel/>
      </div>
    </div>
  )
}



// ── Nhật ký mẻ luyện ──
const VH_HEAT_LOG = [
  {
    stt:1, heat1:"5657", heat2:"5658", tuoiLo:63,
    gangLong:196, thepPhe:22.5, xiFeSi:3.6, gangGong:1273,
    oxyGio:36, apLucO2:78, thoiGian:"35:10", thoiGianTBC:"1:12",
    lieuVao:{ toVoi:99, daDolomit:158, dacVoi:0, quartz:0, totalDa:300 },
    thanhPhanCuoi:{ C:25, Mn:25, P:23, S:15 },
    suc:40,nhiemCarbon:25,nhietDo:1705,
    hopKimSat:{ FeSi:0, FeMn:40, FeSiMn:35, FeCr:10, FiAlSi:5 },
    chatKhu:0, luongThep:"4'00", gianThoiThep:10, nhietDoCho:1632, thoiGianRo:"1'40",
    thanhPhan:{ C:6, Si:11, Mn:34, S:35, P:22 }, mac:"Khởi đầu"
  },
  {
    stt:2, heat1:"5669", heat2:"5670", tuoiLo:63,
    gangLong:197, thepPhe:30, xiFeSi:3.2, gangGong:1212,
    oxyGio:38, apLucO2:81, thoiGian:"35:14", thoiGianTBC:"1:09",
    lieuVao:{ toVoi:99, daDolomit:154, dacVoi:14, quartz:1100, totalDa:300 },
    thanhPhanCuoi:{ C:6, Mn:32, P:26, S:34 },
    suc:40,nhiemCarbon:0,nhietDo:1705,
    hopKimSat:{ FeSi:0, FeMn:40, FeSiMn:35, FeCr:10, FiAlSi:5 },
    chatKhu:0, luongThep:"4'00", gianThoiThep:10, nhietDoCho:1820, thoiGianRo:"1'30",
    thanhPhan:{ C:6, Si:13, Mn:36, S:35, P:23 }, mac:"Đặc biệt"
  },
  {
    stt:3, heat1:"5659", heat2:"5660", tuoiLo:65,
    gangLong:199, thepPhe:29, xiFeSi:3.0, gangGong:1235,
    oxyGio:40, apLucO2:79, thoiGian:"35:10", thoiGianTBC:"1:10",
    lieuVao:{ toVoi:100, daDolomit:147, dacVoi:14, quartz:1100, totalDa:300 },
    thanhPhanCuoi:{ C:8, Mn:28, P:21, S:37 },
    suc:40,nhiemCarbon:0,nhietDo:1700,
    hopKimSat:{ FeSi:0, FeMn:40, FeSiMn:35, FeCr:10, FiAlSi:5 },
    chatKhu:0, luongThep:"4'01", gianThoiThep:10, nhietDoCho:1630, thoiGianRo:"1'50",
    thanhPhan:{ C:6, Si:13, Mn:36, S:35, P:23 }, mac:"SAE"
  },
  {
    stt:4, heat1:"5660", heat2:"5660", tuoiLo:65,
    gangLong:199, thepPhe:29, xiFeSi:3.0, gangGong:null,
    oxyGio:40, apLucO2:null, thoiGian:null, thoiGianTBC:null,
    lieuVao:{ toVoi:null, daDolomit:null, dacVoi:null, quartz:null, totalDa:null },
    thanhPhanCuoi:{ C:null, Mn:null, P:null, S:null },
    suc:null,nhiemCarbon:null,nhietDo:null,
    hopKimSat:{ FeSi:null, FeMn:10, FeSiMn:null, FeCr:null, FiAlSi:null },
    chatKhu:null, luongThep:"4'01", gianThoiThep:10, nhietDoCho:null, thoiGianRo:null,
    thanhPhan:{ C:null, Si:null, Mn:null, S:null, P:null }, mac:"SAE"
  },
  {
    stt:5, heat1:"5661", heat2:"5662", tuoiLo:67,
    gangLong:201, thepPhe:30, xiFeSi:3.2, gangGong:null,
    oxyGio:null, apLucO2:null, thoiGian:null, thoiGianTBC:null,
    lieuVao:{ toVoi:null, daDolomit:null, dacVoi:null, quartz:null, totalDa:null },
    thanhPhanCuoi:{ C:null, Mn:null, P:null, S:null },
    suc:null,nhiemCarbon:null,nhietDo:null,
    hopKimSat:{ FeSi:null, FeMn:null, FeSiMn:null, FeCr:null, FiAlSi:null },
    chatKhu:null, luongThep:"4'02", gianThoiThep:10, nhietDoCho:null, thoiGianRo:null,
    thanhPhan:{ C:null, Si:null, Mn:null, S:null, P:null }, mac:"SAE"
  },
]

// ── Spark analyses: one per heat (keyed by heat1) ──
const VH_SPARK_DB = {
  "5657": {
    id:"GP1-05657", date:"7/2/2025 08:12:04 AM", mac:"NORM",
    elements:[
      { el:"C",  label:"Carbon",    m1:"0.0602",   m2:"0.0598",   mean:"0.0600",  unit:"%"  },
      { el:"Si", label:"Silic",     m1:"0.112",    m2:"0.115",    mean:"0.113",   unit:"%"  },
      { el:"Mn", label:"Mangan",    m1:"0.340",    m2:"0.345",    mean:"0.342",   unit:"%"  },
      { el:"S",  label:"Lưu huỳnh",m1:"0.6120",   m2:"0.6085",   mean:"0.6103",  unit:"%", alarm:true },
      { el:"P",  label:"Phốt pho",  m1:"0.0212",   m2:"0.0218",   mean:"0.0215",  unit:"%"  },
      { el:"Ni", label:"Niken",     m1:"0.0038",   m2:"0.0042",   mean:"0.0040",  unit:"%"  },
      { el:"Cr", label:"Crôm",      m1:"0.0461",   m2:"0.0458",   mean:"0.0460",  unit:"%"  },
      { el:"Cu", label:"Đồng",      m1:"0.0472",   m2:"0.0475",   mean:"0.0473",  unit:"%"  },
      { el:"Mo", label:"Molypden",  m1:"0.0031",   m2:"0.0033",   mean:"0.0032",  unit:"%"  },
      { el:"V",  label:"Vanadi",    m1:"0.0018",   m2:"0.0021",   mean:"0.0019",  unit:"%"  },
      { el:"Al", label:"Nhôm",      m1:"0.0035",   m2:"0.0028",   mean:"0.0031",  unit:"%"  },
      { el:"As", label:"Asen",      m1:"0.0481",   m2:"0.0469",   mean:"0.0475",  unit:"%"  },
      { el:"Fe", label:"Sắt",       m1:"99.1",     m2:"99.1",     mean:"99.1",    unit:"%"  },
      { el:"Zn", label:"Kẽm",       m1:"<0.00100", m2:"<0.00100", mean:"<0.00100",unit:"%"  },
      { el:"Pb", label:"Chì",       m1:"0.0158",   m2:"0.0162",   mean:"0.0160",  unit:"%"  },
      { el:"Sn", label:"Thiếc",     m1:"0.0271",   m2:"0.0265",   mean:"0.0268",  unit:"%"  },
      { el:"Ti", label:"Titan",     m1:"<0.00020", m2:"<0.00020", mean:"<0.00020",unit:"%"  },
      { el:"B",  label:"Bo",        m1:"0.00038",  m2:"0.00044",  mean:"0.00041", unit:"%"  },
      { el:"Co", label:"Coban",     m1:"<0.00100", m2:"<0.00100", mean:"<0.00100",unit:"%"  },
    ]
  },
  "5669": {
    id:"GP1-05658", date:"7/2/2025 10:55:17 AM", mac:"NORM",
    elements:[
      { el:"C",  label:"Carbon",    m1:"0.0602",   m2:"0.0598",   mean:"0.0625",  unit:"%"  },
      { el:"Si", label:"Silic",     m1:"0.131",    m2:"0.130",    mean:"0.130",   unit:"%"  },
      { el:"Mn", label:"Mangan",    m1:"0.354",    m2:"0.357",    mean:"0.355",   unit:"%"  },
      { el:"S",  label:"Lưu huỳnh",m1:"0.6378",   m2:"0.6329",   mean:"0.6353",  unit:"%", alarm:true },
      { el:"P",  label:"Phốt pho",  m1:"0.0238",   m2:"0.0225",   mean:"0.0232",  unit:"%"  },
      { el:"Ni", label:"Niken",     m1:"0.0044",   m2:"0.0071",   mean:"0.0057",  unit:"%"  },
      { el:"Cr", label:"Crôm",      m1:"0.0478",   m2:"0.0473",   mean:"0.0476",  unit:"%"  },
      { el:"Cu", label:"Đồng",      m1:"0.0480",   m2:"0.0481",   mean:"0.0481",  unit:"%"  },
      { el:"Mo", label:"Molypden",  m1:"0.0036",   m2:"0.0038",   mean:"0.0037",  unit:"%"  },
      { el:"V",  label:"Vanadi",    m1:"0.0020",   m2:"0.0024",   mean:"0.0022",  unit:"%"  },
      { el:"Al", label:"Nhôm",      m1:"0.0038",   m2:"0.0023",   mean:"0.0030",  unit:"%"  },
      { el:"As", label:"Asen",      m1:"0.0490",   m2:"0.0472",   mean:"0.0484",  unit:"%"  },
      { el:"Fe", label:"Sắt",       m1:"99.1",     m2:"99.1",     mean:"99.1",    unit:"%"  },
      { el:"Zn", label:"Kẽm",       m1:"<0.00100", m2:"<0.00100", mean:"<0.00100",unit:"%"  },
      { el:"Pb", label:"Chì",       m1:"0.0163",   m2:"0.0177",   mean:"0.0170",  unit:"%"  },
      { el:"Sn", label:"Thiếc",     m1:"0.0280",   m2:"0.0273",   mean:"0.0278",  unit:"%"  },
      { el:"Ti", label:"Titan",     m1:"<0.00020", m2:"<0.00020", mean:"<0.00020",unit:"%"  },
      { el:"B",  label:"Bo",        m1:"0.00040",  m2:"0.00054",  mean:"0.00047", unit:"%"  },
      { el:"Co", label:"Coban",     m1:"<0.00100", m2:"<0.00100", mean:"<0.00100",unit:"%"  },
    ]
  },
  "5659": {
    id:"GP1-05659", date:"7/2/2025 13:40:22 PM", mac:"SAE",
    elements:[
      { el:"C",  label:"Carbon",    m1:"0.0781",   m2:"0.0774",   mean:"0.0778",  unit:"%"  },
      { el:"Si", label:"Silic",     m1:"0.198",    m2:"0.201",    mean:"0.199",   unit:"%"  },
      { el:"Mn", label:"Mangan",    m1:"0.612",    m2:"0.608",    mean:"0.610",   unit:"%"  },
      { el:"S",  label:"Lưu huỳnh",m1:"0.0312",   m2:"0.0298",   mean:"0.0305",  unit:"%"  },
      { el:"P",  label:"Phốt pho",  m1:"0.0189",   m2:"0.0195",   mean:"0.0192",  unit:"%"  },
      { el:"Ni", label:"Niken",     m1:"0.0082",   m2:"0.0079",   mean:"0.0080",  unit:"%"  },
      { el:"Cr", label:"Crôm",      m1:"0.0501",   m2:"0.0498",   mean:"0.0500",  unit:"%"  },
      { el:"Cu", label:"Đồng",      m1:"0.0512",   m2:"0.0515",   mean:"0.0513",  unit:"%"  },
      { el:"Mo", label:"Molypden",  m1:"0.0041",   m2:"0.0039",   mean:"0.0040",  unit:"%"  },
      { el:"V",  label:"Vanadi",    m1:"0.0025",   m2:"0.0022",   mean:"0.0023",  unit:"%"  },
      { el:"Al", label:"Nhôm",      m1:"0.0312",   m2:"0.0298",   mean:"0.0305",  unit:"%"  },
      { el:"As", label:"Asen",      m1:"0.0420",   m2:"0.0415",   mean:"0.0418",  unit:"%"  },
      { el:"Fe", label:"Sắt",       m1:"99.0",     m2:"99.0",     mean:"99.0",    unit:"%"  },
      { el:"Zn", label:"Kẽm",       m1:"<0.00100", m2:"<0.00100", mean:"<0.00100",unit:"%"  },
      { el:"Pb", label:"Chì",       m1:"0.0145",   m2:"0.0151",   mean:"0.0148",  unit:"%"  },
      { el:"Sn", label:"Thiếc",     m1:"0.0258",   m2:"0.0262",   mean:"0.0260",  unit:"%"  },
      { el:"Ti", label:"Titan",     m1:"<0.00020", m2:"<0.00020", mean:"<0.00020",unit:"%"  },
      { el:"B",  label:"Bo",        m1:"0.00051",  m2:"0.00048",  mean:"0.00049", unit:"%"  },
      { el:"Co", label:"Coban",     m1:"<0.00100", m2:"<0.00100", mean:"<0.00100",unit:"%"  },
    ]
  },
}

// ─── Chất Lượng Mẻ Thép ────────────────────────────────────

function ChatLuongMeThepView() {
  const [selHeat, setSelHeat] = useState(VH_HEAT_LOG[0])

  // Derive spark data for selected heat — fallback to first available
  const spark = VH_SPARK_DB[selHeat?.heat1] || VH_SPARK_DB[Object.keys(VH_SPARK_DB)[0]]
  const hasAnalysis = !!VH_SPARK_DB[selHeat?.heat1]

  return (
    <div style={{flex:1,overflow:"auto",padding:"14px 16px",background:"#f8fafc"}}>

      {/* ══ BẢNG GHI CHÉP MẺ LUYỆN ══════════════════════════════ */}
      <div style={{
        background:"white",border:"1px solid #e2e8f0",borderRadius:8,
        padding:"12px 16px",marginBottom:10,
        boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
      }}>
        <div style={{
          display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12
        }}>
          <div>
            <div style={{fontSize:12,fontWeight:700,color:"#1e3a5f",letterSpacing:0.5}}>
              Bảng Ghi Chép Mẻ Luyện
            </div>
            <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>
              BNT-00-02 · Tháng 7 · 2025 — Nhấp vào hàng để xem phân tích
            </div>
          </div>
          <div style={{display:"flex",gap:6,alignItems:"center"}}>
            <span style={{fontSize:10,color:"#94a3b8"}}>{VH_HEAT_LOG.length} mẻ</span>
            <div style={{width:1,height:14,background:"#e2e8f0"}}/>
            <span style={{fontSize:9,fontWeight:700,color:"#22c55e",
              background:"#dcfce7",padding:"2px 8px",borderRadius:8}}>
              Đang ghi
            </span>
          </div>
        </div>

        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:10,minWidth:900}}>
            <thead>
              <tr>
                {[
                  {label:"Số mẻ",     span:2, bg:"#eff6ff"},
                  {label:"Gia nhập liệu (T)", span:4, bg:"#fef9c3"},
                  {label:"Luyện O₂",  span:3, bg:"#fee2e2"},
                  {label:"Thành phần cuối (%)", span:4, bg:"#f0fdf4"},
                  {label:"Nhiệt",     span:2, bg:"#fef2f2"},
                  {label:"Rót thép",  span:2, bg:"#f5f3ff"},
                  {label:"Mác",       span:1, bg:"#f8fafc"},
                  {label:"Phân tích", span:1, bg:"#f0f9ff"},
                ].map(g=>(
                  <th key={g.label} colSpan={g.span} style={{
                    padding:"5px 8px",border:"1px solid #e2e8f0",
                    fontSize:9,fontWeight:700,color:"#1e3a5f",
                    textAlign:"center",background:g.bg
                  }}>{g.label}</th>
                ))}
              </tr>
              <tr style={{background:"#f8fafc",borderBottom:"2px solid #e2e8f0"}}>
                {["STT","Mẻ số","Gang (T)","Phế (T)","Xi Fe","Gông (Nm³)",
                  "O₂ (Nm³/h)","Áp (MPa)","T.gian (s)",
                  "C","Mn","P","S",
                  "Suc","Nhiệt (°C)","4'00 T","T.gian rót","Mác","Kết quả"].map(h=>(
                  <th key={h} style={{
                    padding:"5px 8px",border:"1px solid #e2e8f0",
                    fontSize:9,fontWeight:600,color:"#64748b",
                    whiteSpace:"nowrap",textAlign:"center"
                  }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {VH_HEAT_LOG.map((row,ri)=>{
                const isSel = selHeat?.stt === row.stt
                const hasAnlz = !!VH_SPARK_DB[row.heat1]
                return (
                  <tr key={row.stt}
                    onClick={()=>setSelHeat(row)}
                    style={{
                      background: isSel ? "#eff6ff" : ri%2===0?"white":"#fafafa",
                      borderBottom: isSel ? "2px solid #2563eb" : "1px solid #f1f5f9",
                      cursor:"pointer",transition:"background .1s",
                      outline: isSel ? "none" : "none",
                    }}
                    onMouseEnter={e=>{ if(!isSel) e.currentTarget.style.background="#f8fafc" }}
                    onMouseLeave={e=>{ if(!isSel) e.currentTarget.style.background=ri%2===0?"white":"#fafafa" }}
                  >
                    {/* STT — with selected indicator */}
                    <td style={{padding:"6px 8px",border:"1px solid #f1f5f9",textAlign:"center",
                      fontWeight:700,fontSize:10,
                      color:isSel?"#2563eb":"#64748b",
                      borderLeft:isSel?"3px solid #2563eb":"3px solid transparent"
                    }}>{row.stt}</td>
                    {/* Mẻ số */}
                    <td style={{padding:"6px 8px",border:"1px solid #f1f5f9",
                      fontFamily:"monospace",color:"#2563eb",fontWeight:700,fontSize:10,whiteSpace:"nowrap"}}>
                      {row.heat1}
                      {row.heat2!==row.heat1&&<><br/><span style={{color:"#94a3b8",fontSize:9}}>{row.heat2}</span></>}
                    </td>
                    {[row.gangLong,row.thepPhe,row.xiFeSi,row.gangGong].map((v,i)=>(
                      <td key={i} style={{padding:"6px 8px",border:"1px solid #f1f5f9",
                        textAlign:"right",fontFamily:"monospace",
                        color:v==null?"#e2e8f0":"#374151",fontWeight:i<2?700:400}}>
                        {v??<span>—</span>}
                      </td>
                    ))}
                    <td style={{padding:"6px 8px",border:"1px solid #f1f5f9",
                      textAlign:"right",fontFamily:"monospace",
                      color:row.oxyGio?"#ef4444":"#e2e8f0",fontWeight:700}}>
                      {row.oxyGio??<span>—</span>}
                    </td>
                    <td style={{padding:"6px 8px",border:"1px solid #f1f5f9",
                      textAlign:"right",fontFamily:"monospace",color:row.apLucO2?"#2563eb":"#e2e8f0"}}>
                      {row.apLucO2??<span>—</span>}
                    </td>
                    <td style={{padding:"6px 8px",border:"1px solid #f1f5f9",
                      textAlign:"center",fontFamily:"monospace",color:row.thoiGian?"#64748b":"#e2e8f0"}}>
                      {row.thoiGian??<span>—</span>}
                    </td>
                    {["C","Mn","P","S"].map(el=>(
                      <td key={el} style={{padding:"6px 8px",border:"1px solid #f1f5f9",
                        textAlign:"right",fontFamily:"monospace",
                        color:row.thanhPhanCuoi[el]>30?"#ef4444":row.thanhPhanCuoi[el]!=null?"#374151":"#e2e8f0",
                        fontWeight:row.thanhPhanCuoi[el]>30?700:400}}>
                        {row.thanhPhanCuoi[el]??<span>—</span>}
                      </td>
                    ))}
                    <td style={{padding:"6px 8px",border:"1px solid #f1f5f9",
                      textAlign:"center",fontFamily:"monospace",color:row.suc?"#64748b":"#e2e8f0"}}>
                      {row.suc??<span>—</span>}
                    </td>
                    <td style={{padding:"6px 8px",border:"1px solid #f1f5f9",textAlign:"right"}}>
                      {row.nhietDo
                        ? <span style={{fontSize:12,fontWeight:800,color:"#ef4444",fontFamily:"monospace"}}>
                            {row.nhietDo}°
                          </span>
                        : <span style={{color:"#e2e8f0"}}>—</span>}
                    </td>
                    <td style={{padding:"6px 8px",border:"1px solid #f1f5f9",
                      textAlign:"center",fontFamily:"monospace",color:"#22c55e",fontWeight:700}}>
                      {row.luongThep}
                    </td>
                    <td style={{padding:"6px 8px",border:"1px solid #f1f5f9",
                      textAlign:"center",fontFamily:"monospace",color:row.thoiGianRo?"#64748b":"#e2e8f0"}}>
                      {row.thoiGianRo??<span>—</span>}
                    </td>
                    {/* Mác */}
                    <td style={{padding:"6px 8px",border:"1px solid #f1f5f9",textAlign:"center"}}>
                      <span style={{
                        fontSize:9,fontWeight:700,
                        background:row.mac==="SAE"?"#ede9fe":row.mac==="Đặc biệt"?"#fee2e2":"#f0fdf4",
                        color:row.mac==="SAE"?"#7c3aed":row.mac==="Đặc biệt"?"#dc2626":"#16a34a",
                        padding:"2px 8px",borderRadius:8
                      }}>{row.mac}</span>
                    </td>
                    {/* Kết quả phân tích */}
                    <td style={{padding:"6px 8px",border:"1px solid #f1f5f9",textAlign:"center"}}>
                      {hasAnlz
                        ? <span style={{
                            fontSize:9,fontWeight:700,
                            background:"#dbeafe",color:"#1d4ed8",
                            padding:"2px 8px",borderRadius:8,
                            display:"inline-flex",alignItems:"center",gap:3
                          }}>
                            🔬 Spark
                          </span>
                        : <span style={{fontSize:9,color:"#cbd5e1"}}>—</span>
                      }
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── Connector arrow ── */}
      <div style={{
        display:"flex",alignItems:"center",justifyContent:"center",
        padding:"6px 0",gap:8
      }}>
        <div style={{
          height:2,flex:1,maxWidth:120,
          background:"linear-gradient(90deg,transparent,#2563eb)",borderRadius:1
        }}/>
        <div style={{
          display:"flex",flexDirection:"column",alignItems:"center",gap:2,
          background:hasAnalysis?"#eff6ff":"#f8fafc",
          border:`1px solid ${hasAnalysis?"#bfdbfe":"#e2e8f0"}`,
          borderRadius:8,padding:"5px 14px",
        }}>
          <span style={{fontSize:18,lineHeight:1}}>🔬</span>
          <span style={{
            fontSize:9,fontWeight:700,
            color:hasAnalysis?"#2563eb":"#94a3b8"
          }}>
            {hasAnalysis
              ? `Mẻ ${selHeat?.heat1} · ${spark.date}`
              : `Mẻ ${selHeat?.heat1 ?? "—"} — chưa có dữ liệu`
            }
          </span>
        </div>
        <div style={{
          height:2,flex:1,maxWidth:120,
          background:"linear-gradient(90deg,#2563eb,transparent)",borderRadius:1
        }}/>
      </div>

      {/* ══ PHÂN TÍCH THÀNH PHẦN THÉP (SPARK ANALYZER) ══════════════ */}
      <div style={{
        background:"white",
        border:`2px solid ${hasAnalysis?"#bfdbfe":"#e2e8f0"}`,
        borderRadius:8,padding:"12px 16px",
        boxShadow:hasAnalysis?"0 0 0 3px rgba(37,99,235,.07)":"0 1px 3px rgba(0,0,0,0.04)",
        transition:"all .2s"
      }}>
        <div style={{
          display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12
        }}>
          <div>
            <div style={{fontSize:12,fontWeight:700,color:"#1e3a5f",letterSpacing:0.5}}>
              Phân Tích Thành Phần — Spark Analyzer Pro MAXx
            </div>
            <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>
              {hasAnalysis
                ? <span>
                    <span style={{
                      background:"#eff6ff",color:"#2563eb",
                      padding:"1px 6px",borderRadius:6,fontWeight:700,marginRight:6
                    }}>Mẻ {selHeat?.heat1}</span>
                    {spark.id} · {spark.date} · Mác: {spark.mac}
                  </span>
                : <span style={{color:"#ef4444"}}>
                    ⚠ Chưa có dữ liệu phân tích cho mẻ {selHeat?.heat1}
                  </span>
              }
            </div>
          </div>
          <div style={{display:"flex",gap:6,alignItems:"center"}}>
            <span style={{fontSize:9,fontWeight:700,background:"#f1f5f9",
              color:"#64748b",padding:"2px 8px",borderRadius:8}}>
              2 lần đo · Trung bình
            </span>
            {!hasAnalysis && (
              <span style={{fontSize:9,fontWeight:700,background:"#fee2e2",
                color:"#dc2626",padding:"2px 8px",borderRadius:8}}>
                Không có dữ liệu
              </span>
            )}
          </div>
        </div>

        {hasAnalysis ? (
          <>
            {/* Element grid */}
            <div style={{
              display:"grid",
              gridTemplateColumns:"repeat(auto-fill,minmax(110px,1fr))",
              gap:6,marginBottom:10
            }}>
              {spark.elements.map(el=>{
                const meanNum = parseFloat(el.mean)
                const isAlarm = el.alarm || (el.el==="S" && meanNum>0.5)
                const isKey   = ["C","Si","Mn","S","P"].includes(el.el)
                return (
                  <div key={el.el} style={{
                    background:isAlarm?"#fef2f2":isKey?"#eff6ff":"#f8fafc",
                    border:`1px solid ${isAlarm?"#fca5a5":isKey?"#bfdbfe":"#e2e8f0"}`,
                    borderRadius:7,padding:"7px 8px",
                    transition:"background .2s"
                  }}>
                    <div style={{display:"flex",alignItems:"baseline",gap:4,marginBottom:4}}>
                      <span style={{fontSize:16,fontWeight:900,fontFamily:"serif",lineHeight:1,
                        color:isAlarm?"#ef4444":isKey?"#1e3a5f":"#374151"}}>{el.el}</span>
                      <span style={{fontSize:8,color:"#94a3b8"}}>{el.label}</span>
                    </div>
                    <div style={{fontSize:14,fontWeight:900,fontFamily:"monospace",lineHeight:1,marginBottom:3,
                      color:isAlarm?"#ef4444":isKey?"#2563eb":"#374151"}}>
                      {el.mean}
                      <span style={{fontSize:8,fontWeight:400,color:"#94a3b8",marginLeft:2}}>{el.unit}</span>
                    </div>
                    <div style={{display:"flex",gap:4,fontSize:8,color:"#94a3b8",fontFamily:"monospace"}}>
                      <span>①{el.m1}</span>
                      <span style={{color:"#e2e8f0"}}>|</span>
                      <span>②{el.m2}</span>
                    </div>
                    {isAlarm&&(
                      <div style={{marginTop:4,fontSize:7,fontWeight:700,color:"#dc2626",
                        background:"#fee2e2",padding:"1px 5px",borderRadius:4,display:"inline-block"}}>
                        ⚠ Cao
                      </div>
                    )}
                  </div>
                )
              })}
            </div>

            {/* Key elements summary bar */}
            <div style={{padding:"8px 12px",background:"#f8fafc",border:"1px solid #e2e8f0",
              borderRadius:6,display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
              <span style={{fontSize:9,fontWeight:700,color:"#64748b",
                letterSpacing:1,textTransform:"uppercase"}}>Nguyên tố chính</span>
              {spark.elements.filter(e=>["C","Si","Mn","S","P"].includes(e.el)).map(el=>{
                const isAlarm = el.el==="S" && parseFloat(el.mean)>0.5
                return (
                  <div key={el.el} style={{display:"flex",gap:5,alignItems:"center",
                    background:"white",border:`1px solid ${isAlarm?"#fca5a5":"#e2e8f0"}`,
                    borderRadius:6,padding:"4px 8px"}}>
                    <span style={{fontSize:12,fontWeight:900,fontFamily:"serif",
                      color:isAlarm?"#ef4444":"#1e3a5f"}}>{el.el}</span>
                    <span style={{fontSize:13,fontWeight:900,fontFamily:"monospace",
                      color:isAlarm?"#ef4444":"#2563eb"}}>{el.mean}</span>
                    <span style={{fontSize:8,color:"#94a3b8"}}>{el.unit}</span>
                  </div>
                )
              })}
            </div>
          </>
        ) : (
          <div style={{
            padding:"40px 0",textAlign:"center",color:"#94a3b8"
          }}>
            <div style={{fontSize:36,marginBottom:8}}>🔬</div>
            <div style={{fontSize:13,fontWeight:600,color:"#64748b",marginBottom:4}}>
              Chưa có kết quả phân tích
            </div>
            <div style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
              Mẻ số <strong style={{color:"#2563eb"}}>{selHeat?.heat1}</strong> chưa được phân tích<br/>
              hoặc dữ liệu Spark Analyzer chưa được nhập
            </div>
          </div>
        )}
      </div>

    </div>
  )
}


// ─── Đúc Liên Tục (CCM) ────────────────────────────────────

// ── Data ──
const CCM_STRANDS = [
  { id:"S1", label:"Dòng 1", active:true,  speed:1.42, setSpeed:1.40, temp:1535, alarm:false, billetLen:12.0, cut:14, color:"#2563eb" },
  { id:"S2", label:"Dòng 2", active:true,  speed:1.38, setSpeed:1.40, temp:1532, alarm:false, billetLen:12.0, cut:13, color:"#2563eb" },
  { id:"S3", label:"Dòng 3", active:false, speed:0,    setSpeed:1.40, temp:null, alarm:false, billetLen:0,    cut:0,  color:"#94a3b8" },
]

const CCM_TUNDISH = {
  temp:    1558, setTemp: 1555,
  level:   72,               // %
  weight:  8.4,              // T
  alarm:   false,
}

const CCM_MOLD = [
  { id:"M1", strand:"S1", waterFlow:180, waterTemp:28.5, coolingOK:true,  oscFreq:1.8, oscAmp:6.0 },
  { id:"M2", strand:"S2", waterFlow:178, waterTemp:29.1, coolingOK:true,  oscFreq:1.8, oscAmp:6.0 },
  { id:"M3", strand:"S3", waterFlow:0,   waterTemp:null, coolingOK:false, oscFreq:0,   oscAmp:0   },
]

const CCM_SECONDARY = [
  { zone:"Zone 1", flow:18.2, setFlow:18.0, tempIn:28, tempOut:36, alarm:false },
  { zone:"Zone 2", flow:12.6, setFlow:12.5, tempIn:28, tempOut:38, alarm:false },
  { zone:"Zone 3", flow:8.4,  setFlow:8.0,  tempIn:28, tempOut:41, alarm:true  },
  { zone:"Zone 4", flow:5.1,  setFlow:5.0,  tempIn:28, tempOut:42, alarm:false },
]

const CCM_CUTTERS = [
  { id:"CS1", strand:"S1", active:true,  lastCut:"08:42:15", nextCut:"3.2m", count:14 },
  { id:"CS2", strand:"S2", active:true,  lastCut:"08:41:58", nextCut:"4.1m", count:13 },
  { id:"CS3", strand:"S3", active:false, lastCut:"—",        nextCut:"—",    count:0  },
]

const CCM_BILLET_SIZE = "150 × 150 mm"
const CCM_BILLET_TOTAL = 27 // billets this shift

// ── Tundish SVG ──
function TundishSVG({ level=72, temp=1558, active=true, w=130, h=70 }) {
  const cx = w/2
  const fillW = (level/100)*(w-20)
  const c = active ? "#1e3a5f" : "#94a3b8"
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block"}}>
      {/* Body trapezoid */}
      <polygon points={`8,4 ${w-8},4 ${w-4},${h-8} 4,${h-8}`}
        fill="white" stroke={c} strokeWidth={1.5}/>
      {/* Steel fill */}
      <clipPath id="tundishclip">
        <polygon points={`9,5 ${w-9},5 ${w-5},${h-9} 5,${h-9}`}/>
      </clipPath>
      <rect x={10} y={5+(h-14)*(1-level/100)} width={w-20} height={(h-14)*(level/100)}
        fill={active?"#fbbf24":"#e2e8f0"} opacity={0.7}
        clipPath="url(#tundishclip)"/>
      {/* Flow nozzles bottom */}
      {[0.28,0.50,0.72].map((f,i)=>(
        <rect key={i} x={w*f-3} y={h-9} width={6} height={10} rx={1}
          fill={i===2&&!active?"#e2e8f0":active?"#ef4444":"#e2e8f0"}/>
      ))}
      {/* Temp label */}
      <text x={cx} y={h*0.45} textAnchor="middle" fontSize={11} fontWeight="800"
        fill={active?"#92400e":"#94a3b8"} fontFamily="monospace">{active?`${temp}°C`:"Dừng"}</text>
      {/* Level label */}
      <text x={cx} y={h*0.65} textAnchor="middle" fontSize={9} fill={active?"#374151":"#94a3b8"}
        fontWeight="600">{active?`${level}%`:""}</text>
      {/* Label */}
      <text x={cx} y={h+2} textAnchor="middle" fontSize={8} fill="#64748b">Thùng trung gian</text>
    </svg>
  )
}

// ── Single strand SVG (vertical casting machine) ──
function StrandSVG({ strand, mold, active=true, w=56, h=200 }) {
  const cx = w/2
  const c  = active ? "#2563eb" : "#94a3b8"
  const speedPct = Math.min((strand.speed/2)*100, 100)
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block"}}>
      {/* Mold box */}
      <rect x={cx-12} y={4} width={24} height={32} rx={3}
        fill="white" stroke={c} strokeWidth={1.5}/>
      {/* Mold label */}
      <text x={cx} y={14} textAnchor="middle" fontSize={7} fill={c} fontWeight="700">KHUÔN</text>
      {/* Oscillation arrows */}
      {active && <>
        <line x1={cx-16} y1={20} x2={cx-20} y2={17} stroke="#f59e0b" strokeWidth={1.5}/>
        <line x1={cx-16} y1={20} x2={cx-20} y2={23} stroke="#f59e0b" strokeWidth={1.5}/>
        <line x1={cx+16} y1={20} x2={cx+20} y2={17} stroke="#f59e0b" strokeWidth={1.5}/>
        <line x1={cx+16} y1={20} x2={cx+20} y2={23} stroke="#f59e0b" strokeWidth={1.5}/>
      </>}
      {/* Steel strand body */}
      <rect x={cx-8} y={36} width={16} height={110} rx={2}
        fill={active?"#fef3c7":"#f1f5f9"} stroke={active?"#f59e0b":"#e2e8f0"} strokeWidth={1}/>
      {/* Cooling spray zones */}
      {[0,1,2,3].map(i=>(
        <g key={i}>
          {active && <>
            <line x1={cx-12} y1={40+i*26} x2={cx-8} y2={44+i*26}
              stroke="#0ea5e9" strokeWidth={1} opacity={0.6}/>
            <line x1={cx+12} y1={40+i*26} x2={cx+8} y2={44+i*26}
              stroke="#0ea5e9" strokeWidth={1} opacity={0.6}/>
          </>}
          <rect x={cx-14} y={38+i*26} width={4} height={10} rx={1}
            fill={active?"#0ea5e9":"#e2e8f0"} opacity={0.7}/>
          <rect x={cx+10} y={38+i*26} width={4} height={10} rx={1}
            fill={active?"#0ea5e9":"#e2e8f0"} opacity={0.7}/>
        </g>
      ))}
      {/* Withdrawal rolls */}
      {[148,158,168].map(y=>(
        <g key={y}>
          <rect x={cx-16} y={y} width={6} height={8} rx={2} fill="#64748b" opacity={0.7}/>
          <rect x={cx+10} y={y} width={6} height={8} rx={2} fill="#64748b" opacity={0.7}/>
        </g>
      ))}
      {/* Cut-off indicator */}
      <line x1={cx-14} y1={178} x2={cx+14} y2={178}
        stroke={active?"#ef4444":"#e2e8f0"} strokeWidth={2} strokeDasharray="4 2"/>
      {/* Speed label */}
      <text x={cx} y={195} textAnchor="middle" fontSize={9} fontWeight="800"
        fill={active?c:"#94a3b8"} fontFamily="monospace">
        {active?`${strand.speed}m/min`:"Dừng"}
      </text>
      {/* Progress bar (speed) */}
      <rect x={cx-12} y={182} width={24} height={4} rx={2} fill="#f1f5f9"/>
      <rect x={cx-12} y={182} width={24*(speedPct/100)} height={4} rx={2}
        fill={speedPct>95?"#ef4444":speedPct>80?"#f59e0b":c}/>
    </svg>
  )
}

function DucLienTucView() {
  const [selStrand, setSelStrand] = useState(CCM_STRANDS[0])
  const [hovId,     setHovId]     = useState(null)
  const [casting,   setCasting]   = useState(true)

  const activeStrands = CCM_STRANDS.filter(s=>s.active).length
  const alarmsN = CCM_SECONDARY.filter(z=>z.alarm).length

  // canonical helpers
  const HPipe = ({color="#22c55e",active=true,width=28,flow=null,unit=""}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{width,height:3,background:active?color:"#e2e8f0",borderRadius:2,
        opacity:active?1:0.5,boxShadow:active?`0 0 4px ${color}66`:"none",transition:"all .2s"}}/>
      {flow!=null&&<span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600,whiteSpace:"nowrap"}}>
        {flow>0?`+${flow}`:flow} {unit}</span>}
    </div>
  )
  const Arrow = ({color="#22c55e",active=true,dir="right"}) => (
    <span style={{fontSize:10,color:active?color:"#e2e8f0",flexShrink:0,lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"}}>
      {dir==="right"?"▶":dir==="down"?"▼":"◀"}
    </span>
  )
  const ColHeader = ({title,count=null,extra=null}) => (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
      <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
        {title}{count!=null&&<span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}> ({count})</span>}
      </span>
      {extra||<div/>}
    </div>
  )

  // ── Strand card — MachineCard pattern ──
  const StrandCard = ({s}) => {
    const isSel = selStrand?.id===s.id
    const isHov = hovId===s.id
    const mold  = CCM_MOLD.find(m=>m.strand===s.id)
    return (
      <div
        onClick={()=>setSelStrand(isSel?null:s)}
        onMouseEnter={()=>setHovId(s.id)}
        onMouseLeave={()=>setHovId(null)}
        style={{
          background:"white",
          border:`2px solid ${isSel?"#2563eb":s.alarm?"#fca5a5":"#e2e8f0"}`,
          borderRadius:8,padding:"12px",cursor:"pointer",
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:s.active?1:0.55
        }}>
        {/* Header */}
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
          <div style={{width:34,height:34,borderRadius:6,
            background:s.active?"#eff6ff":"#f1f5f9",
            display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>
            {s.active?"🔩":"○"}
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{s.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{s.id} · {CCM_BILLET_SIZE}</div>
          </div>
          <span style={{fontSize:9,fontWeight:600,padding:"1px 6px",borderRadius:8,
            background:s.active?"#dcfce7":"#fee2e2",
            color:s.active?"#16a34a":"#dc2626"}}>
            {s.active?"Đang đúc":"Dừng"}
          </span>
        </div>
        {/* Strand SVG */}
        <div style={{display:"flex",justifyContent:"center",marginBottom:8}}>
          <StrandSVG strand={s} mold={mold} active={s.active} w={56} h={180}/>
        </div>
        {/* Speed + temp */}
        <div style={{display:"flex",gap:10,marginBottom:8}}>
          <div style={{flex:1}}>
            <div style={{fontSize:9,color:"#94a3b8",marginBottom:1}}>Tốc độ kéo</div>
            <div style={{fontSize:20,fontWeight:900,color:s.active?"#2563eb":"#94a3b8",
              lineHeight:1,fontFamily:"monospace"}}>
              {s.speed}<span style={{fontSize:9,fontWeight:400,color:"#94a3b8",marginLeft:2}}>m/min</span>
            </div>
            <div style={{fontSize:8,color:Math.abs(s.speed-s.setSpeed)<0.05?"#22c55e":"#f59e0b",marginTop:1}}>
              Cài: {s.setSpeed} m/min
            </div>
          </div>
          {s.temp&&(
            <div style={{flex:1}}>
              <div style={{fontSize:9,color:"#94a3b8",marginBottom:1}}>Nhiệt độ</div>
              <div style={{fontSize:16,fontWeight:700,color:"#f97316",lineHeight:1,fontFamily:"monospace"}}>
                {s.temp}<span style={{fontSize:9,fontWeight:400,color:"#94a3b8",marginLeft:2}}>°C</span>
              </div>
            </div>
          )}
        </div>
        {/* Speed progress */}
        <div style={{height:5,background:"#f1f5f9",borderRadius:3,overflow:"hidden",marginBottom:6}}>
          <div style={{height:"100%",borderRadius:3,transition:"width .3s",
            width:s.active?`${Math.min((s.speed/2)*100,100)}%`:"0%",
            background:s.speed>1.9?"#ef4444":s.speed>1.5?"#f59e0b":"#22c55e"}}/>
        </div>
        {/* Billet count */}
        {s.active&&(
          <div style={{
            background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:5,
            padding:"4px 8px",display:"flex",justifyContent:"space-between"
          }}>
            <span style={{fontSize:9,color:"#94a3b8"}}>Phôi ca này</span>
            <span style={{fontSize:11,fontWeight:700,color:"#374151",fontFamily:"monospace"}}>{s.cut} phôi</span>
          </div>
        )}
      </div>
    )
  }

  // ── Secondary cooling card — OutputCard pattern ──
  const CoolingZoneCard = ({zone}) => {
    const isSel = selStrand?.id===`Z${zone.zone.slice(-1)}`
    return (
      <div style={{
        background:"white",border:`2px solid ${zone.alarm?"#fca5a5":"#e2e8f0"}`,
        borderRadius:8,padding:"10px 12px",marginBottom:8,
        boxShadow:"0 1px 3px rgba(0,0,0,0.04)",
        opacity:1
      }}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:6}}>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:13}}>💧</span>
            <div>
              <div style={{fontSize:10,fontWeight:700,color:"#374151"}}>{zone.zone}</div>
              <div style={{fontSize:8,fontFamily:"monospace",color:"#94a3b8"}}>Làm mát thứ cấp</div>
            </div>
          </div>
          {zone.alarm&&<span style={{width:16,height:16,borderRadius:"50%",background:"#ef4444",
            display:"inline-flex",alignItems:"center",justifyContent:"center",
            fontSize:7,color:"white",fontWeight:900}}>!</span>}
        </div>
        {/* Flow row — FlowCard pattern */}
        <div style={{display:"flex",alignItems:"center",gap:4,marginBottom:4}}>
          <Arrow color="#0ea5e9" active={true} dir="right"/>
          <HPipe color="#0ea5e9" active={true} width={10}/>
          <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
            <rect x={1} y={2} width={12} height={14} rx={2} fill="white"
              stroke="#0ea5e9" strokeWidth={1.5}/>
            <circle cx={7} cy={9} r={3} fill="#0ea5e9" opacity={0.25}/>
            <circle cx={7} cy={9} r={1.5} fill="#0ea5e9"/>
            <line x1={13} y1={9} x2={18} y2={9} stroke="#0ea5e9" strokeWidth={1.5}/>
            <rect x={18} y={2} width={9} height={14} rx={2} fill="white"
              stroke="#0ea5e9" strokeWidth={1.5}/>
          </svg>
          <HPipe color="#0ea5e9" active={true} width={6}/>
          <div style={{flex:1,textAlign:"right"}}>
            <span style={{fontSize:14,fontWeight:800,color:"#0ea5e9",fontFamily:"monospace"}}>
              {zone.flow}
            </span>
            <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>m³/h</span>
          </div>
        </div>
        {/* Temp delta */}
        <div style={{
          display:"flex",justifyContent:"space-between",
          padding:"3px 6px",background:"#f8fafc",borderRadius:5,
          border:`1px solid ${zone.alarm?"#fca5a5":"#e2e8f0"}`
        }}>
          <span style={{fontSize:9,color:"#94a3b8"}}>ΔT vào/ra</span>
          <span style={{fontSize:10,fontWeight:700,fontFamily:"monospace",
            color:zone.alarm?"#ef4444":zone.tempOut>40?"#f59e0b":"#374151"}}>
            {zone.tempIn}° → {zone.tempOut}°C
          </span>
        </div>
        {/* Setpoint */}
        <div style={{marginTop:4,fontSize:9,color:"#64748b"}}>
          Cài đặt: <span style={{fontWeight:600,fontFamily:"monospace",color:"#374151"}}>
            {zone.setFlow} m³/h
          </span>
          <span style={{marginLeft:6,
            color:Math.abs(zone.flow-zone.setFlow)<0.3?"#22c55e":"#f59e0b",
            fontSize:9,fontWeight:600}}>
            Δ {Math.abs(zone.flow-zone.setFlow).toFixed(1)}
          </span>
        </div>
      </div>
    )
  }

  // ── Detail panel ──
  const DetailPanel = () => {
    if (!selStrand) return (
      <div style={{height:"100%",display:"flex",flexDirection:"column",
        alignItems:"center",justifyContent:"center",
        color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8}}>
        <span style={{fontSize:32}}>🔩</span>
        <span style={{fontWeight:600,color:"#64748b"}}>Chọn dòng đúc</span>
        <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
          Nhấp vào dòng đúc để xem thông số chi tiết
        </span>
      </div>
    )
    const s    = selStrand
    const mold = CCM_MOLD.find(m=>m.strand===s.id)
    const cut  = CCM_CUTTERS.find(c=>c.strand===s.id)
    const trend = Array.from({length:18},(_,i)=>
      Math.max(5,Math.min(95,70+Math.sin(i/3)*15+(Math.random()-.5)*8))
    )
    return (
      <div>
        <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
          display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{s.id} · </span>
            <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{s.label}</span>
          </div>
          <span style={{fontSize:9,fontWeight:600,padding:"2px 7px",borderRadius:8,
            background:s.active?"#dcfce7":"#fee2e2",
            color:s.active?"#16a34a":"#dc2626"}}>
            {s.active?"Đang đúc":"Dừng"}
          </span>
        </div>
        <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
          {["Thông tin","Cảnh báo"].map((t,i)=>(
            <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
              fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
              borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",
              background:"none"}}>{t}</button>
          ))}
        </div>
        {/* Mini strand visual */}
        <div style={{padding:"10px",background:"white",borderBottom:"1px solid #f1f5f9",
          display:"flex",justifyContent:"center"}}>
          <StrandSVG strand={s} mold={mold} active={s.active} w={48} h={160}/>
        </div>
        {/* Fields */}
        {[
          ["Tốc độ kéo",   s.active?`${s.speed} m/min`:"—"],
          ["Cài đặt tốc",  `${s.setSpeed} m/min`],
          ["Nhiệt độ",     s.temp?`${s.temp} °C`:"—"],
          ["Kích thước",   CCM_BILLET_SIZE],
          ["Phôi ca này",  `${s.cut} phôi`],
          ...(mold?[
            ["Nước khuôn",  `${mold.waterFlow} L/min`],
            ["T° nước khuôn",`${mold.waterTemp??'—'} °C`],
            ["Tần số dao",  `${mold.oscFreq} Hz`],
          ]:[]),
          ...(cut?[
            ["Cắt cuối",    cut.lastCut],
            ["Cắt tiếp",    cut.nextCut],
          ]:[]),
        ].map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",
            padding:"6px 14px",borderBottom:"1px solid #f8fafc"}}>
            <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
            <span style={{fontSize:11,fontWeight:600,color:"#0f172a"}}>{v}</span>
          </div>
        ))}
        {/* Trend */}
        <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
          color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>THAM SỐ 1H QUA</div>
        <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
          <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
            {trend.map((v,i)=>(
              <div key={i} style={{flex:1,height:`${v}%`,
                background:"#2563eb",borderRadius:"1px 1px 0 0",opacity:0.8}}/>
            ))}
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
            <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
            <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>

      {/* ── Main canvas ── */}
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

        {/* KPI strip */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"Dòng đang đúc",  value:`${activeStrands}/${CCM_STRANDS.length}`,icon:"🔩",color:"#2563eb"},
            {label:"Tốc độ TB",      value:"1.40 m/min",  icon:"⚡", color:"#2563eb"},
            {label:"Nhiệt độ TB",    value:"1 534 °C",    icon:"🌡", color:"#f97316"},
            {label:"Thùng TG",       value:`${CCM_TUNDISH.temp}°C · ${CCM_TUNDISH.level}%`,icon:"🪣",color:"#f59e0b"},
            {label:"Phôi ca này",    value:`${CCM_BILLET_TOTAL} phôi`,icon:"📦",color:"#22c55e"},
            {label:"Cảnh báo",       value:`${alarmsN}`,  icon:"⚠",  color:alarmsN>0?"#ef4444":"#22c55e"},
          ].map(k=>(
            <div key={k.label} style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,
              flex:1,minWidth:100,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:14,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* 3-column layout */}
        <div style={{display:"flex",gap:0,minWidth:600}}>

          {/* ── COL 1: Tundish + Mold params ── */}
          <div style={{width:210,borderRight:"1px solid #e2e8f0",paddingRight:12,flexShrink:0}}>
            <ColHeader title="Thùng trung gian"/>

            {/* Tundish card */}
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"12px",marginBottom:8,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <div style={{display:"flex",justifyContent:"center",marginBottom:8}}>
                <TundishSVG temp={CCM_TUNDISH.temp} level={CCM_TUNDISH.level}
                  active={casting} w={130} h={70}/>
              </div>
              {[
                {k:"Nhiệt độ thép",  v:`${CCM_TUNDISH.temp} °C`,  c:"#f97316"},
                {k:"Cài đặt T°",    v:`${CCM_TUNDISH.setTemp} °C`,c:"#64748b"},
                {k:"Mức thép",       v:`${CCM_TUNDISH.level}%`,   c:"#2563eb"},
                {k:"Khối lượng",     v:`${CCM_TUNDISH.weight} T`, c:"#374151"},
              ].map(r=>(
                <div key={r.k} style={{display:"flex",justifyContent:"space-between",
                  padding:"4px 0",borderBottom:"1px solid #f8fafc"}}>
                  <span style={{fontSize:9,color:"#94a3b8"}}>{r.k}</span>
                  <span style={{fontSize:12,fontWeight:800,color:r.c,fontFamily:"monospace"}}>{r.v}</span>
                </div>
              ))}
            </div>

            {/* Mold cooling table */}
            <ColHeader title="Khuôn đúc" count={CCM_MOLD.length}/>
            {CCM_MOLD.map(m=>(
              <div key={m.id} style={{
                background:"white",border:"1px solid #e2e8f0",
                borderRadius:8,padding:"8px 10px",marginBottom:8,
                boxShadow:"0 1px 3px rgba(0,0,0,0.04)",
                opacity:m.coolingOK||m.waterFlow>0?1:0.5
              }}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:5}}>
                  <span style={{fontSize:10,fontWeight:700,color:"#374151"}}>{m.id} · {m.strand}</span>
                  <span style={{fontSize:8,fontWeight:700,
                    background:m.coolingOK?"#dcfce7":"#fee2e2",
                    color:m.coolingOK?"#16a34a":"#dc2626",
                    padding:"1px 5px",borderRadius:6}}>
                    {m.coolingOK?"OK":"Dừng"}
                  </span>
                </div>
                {[
                  {k:"Nước khuôn", v:`${m.waterFlow} L/min`, c:"#0ea5e9"},
                  {k:"T° nước",    v:m.waterTemp?`${m.waterTemp} °C`:"—", c:"#f59e0b"},
                  {k:"Tần số",     v:`${m.oscFreq} Hz`,       c:"#64748b"},
                ].map(r=>(
                  <div key={r.k} style={{display:"flex",justifyContent:"space-between",
                    padding:"3px 0",borderBottom:"1px solid #f8fafc"}}>
                    <span style={{fontSize:8,color:"#94a3b8"}}>{r.k}</span>
                    <span style={{fontSize:10,fontWeight:700,color:r.c,fontFamily:"monospace"}}>{r.v}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* ── COL 2: Strand cards ── */}
          <div style={{flex:1,borderRight:"1px solid #e2e8f0",padding:"0 12px",minWidth:200}}>
            <ColHeader title="Dòng đúc" count={CCM_STRANDS.length} extra={
              <div style={{display:"flex",gap:4}}>
                <button onClick={()=>setCasting(true)} style={{
                  padding:"3px 8px",border:"none",borderRadius:5,cursor:"pointer",
                  fontSize:9,fontWeight:600,
                  background:casting?"#22c55e":"#f1f5f9",color:casting?"white":"#64748b"
                }}>▶</button>
                <button onClick={()=>setCasting(false)} style={{
                  padding:"3px 8px",border:"none",borderRadius:5,cursor:"pointer",
                  fontSize:9,fontWeight:600,
                  background:!casting?"#ef4444":"#f1f5f9",color:!casting?"white":"#64748b"
                }}>■</button>
              </div>
            }/>
            <div style={{display:"flex",gap:8}}>
              {CCM_STRANDS.map(s=><StrandCard key={s.id} s={s}/>)}
            </div>

            {/* Flame cutter status */}
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",marginTop:8,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>
                Máy Cắt Phôi
              </div>
              {CCM_CUTTERS.map(c=>(
                <div key={c.id} style={{
                  display:"flex",alignItems:"center",justifyContent:"space-between",
                  padding:"5px 0",borderBottom:"1px solid #f8fafc"
                }}>
                  <span style={{fontSize:9,color:"#64748b",width:40}}>{c.id}</span>
                  <span style={{
                    fontSize:8,fontWeight:700,
                    background:c.active?"#dcfce7":"#f1f5f9",
                    color:c.active?"#16a34a":"#94a3b8",
                    padding:"1px 5px",borderRadius:6
                  }}>{c.active?"Đang cắt":"Dừng"}</span>
                  <span style={{fontSize:9,fontFamily:"monospace",color:"#2563eb",fontWeight:600}}>
                    {c.count} phôi
                  </span>
                  <span style={{fontSize:8,color:"#94a3b8"}}>↑ {c.nextCut}</span>
                </div>
              ))}
            </div>
          </div>

          {/* ── COL 3: Secondary cooling + outputs ── */}
          <div style={{flex:1,paddingLeft:12,minWidth:170}}>
            <div style={{display:"flex",alignItems:"center",marginBottom:12}}>
              <Arrow color="#0ea5e9" active={true} dir="right"/>
              <HPipe color="#0ea5e9" active={true} width={12}/>
              <div style={{flex:1}}>
                <ColHeader title="Làm mát thứ cấp" count={CCM_SECONDARY.length}/>
              </div>
            </div>
            {CCM_SECONDARY.map(z=><CoolingZoneCard key={z.zone} zone={z}/>)}

            {/* Billet output card */}
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",marginTop:4,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8,
                display:"flex",alignItems:"center",gap:6}}>
                📦 Phôi Thép Ra
              </div>
              {[
                {k:"Kích thước phôi", v:CCM_BILLET_SIZE,        c:"#374151"},
                {k:"Chiều dài cắt",  v:"12.0 m",               c:"#374151"},
                {k:"Tổng ca này",    v:`${CCM_BILLET_TOTAL} phôi`, c:"#22c55e"},
                {k:"Dòng 1",         v:`${CCM_STRANDS[0].cut} phôi`,c:"#2563eb"},
                {k:"Dòng 2",         v:`${CCM_STRANDS[1].cut} phôi`,c:"#2563eb"},
              ].map(r=>(
                <div key={r.k} style={{display:"flex",justifyContent:"space-between",
                  alignItems:"center",padding:"5px 0",borderBottom:"1px solid #f8fafc"}}>
                  <span style={{fontSize:9,color:"#94a3b8"}}>{r.k}</span>
                  <span style={{fontSize:12,fontWeight:800,color:r.c,fontFamily:"monospace"}}>{r.v}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>

      {/* ── Right detail panel 268px ── */}
      <div style={{
        width:268,background:"white",borderLeft:"1px solid #e2e8f0",
        flexShrink:0,overflowY:"auto"
      }}>
        <DetailPanel/>
      </div>
    </div>
  )
}


function PXLTPanel() {
  const [search,       setSearch]       = useState("")
  const [filterType,   setFilterType]   = useState("Tous")
  const [alarmOnly,    setAlarmOnly]    = useState(false)
  const [viewMode,     setViewMode]     = useState("table")
  const [selectedItem, setSelectedItem] = useState(null)

  const types = ["Tous", ...Array.from(new Set(PXLT_DATA.map(d=>d.type)))]

  const filtered = PXLT_DATA.filter(d => {
    if (alarmOnly && !d.alarm) return false
    if (filterType !== "Tous" && d.type !== filterType) return false
    if (search && !d.name.toLowerCase().includes(search.toLowerCase()) &&
                  !d.id.toLowerCase().includes(search.toLowerCase())) return false
    return true
  })

  // Reuse same STATUS_STYLES as PXLG
  const STATUS_STYLES = PXLG_STATUS_STYLES

  const [pxltSubTab, setPxltSubTab] = useState("Phối Liệu Lò Chuyển")

  return (
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",background:"#f8fafc"}}>

      {/* Tab bar — same pattern as PXLGPanel */}
      <div style={{
        background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"0 16px",display:"flex",alignItems:"center",gap:4,flexShrink:0
      }}>
        {["Thiết bị","Phối Liệu Lò Chuyển","Vận hành lò chuyển","Chất Lượng Mẻ thép","Đúc Liên Tục"].map(t=>(
          <button key={t} onClick={()=>setPxltSubTab(t)} style={{
            padding:"10px 16px",border:"none",cursor:"pointer",fontSize:12,fontWeight:500,
            background:"transparent",
            color:pxltSubTab===t?"#1e3a5f":"#64748b",
            borderBottom:pxltSubTab===t?"2px solid #1e3a5f":"2px solid transparent",
            transition:"all .15s",whiteSpace:"nowrap"
          }}>{t}</button>
        ))}
      </div>

      {pxltSubTab==="Phối Liệu Lò Chuyển" ? <LoCaoBOFView/> : pxltSubTab==="Vận hành lò chuyển" ? <VanHanhLoChuYenView/> : pxltSubTab==="Chất Lượng Mẻ thép" ? <ChatLuongMeThepView/> : pxltSubTab==="Đúc Liên Tục" ? <DucLienTucView/> : (
      <>
      {/* Toolbar — identical to PXLGPanel */}
      <div style={{
        background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"10px 16px",display:"flex",alignItems:"center",gap:10,flexShrink:0,flexWrap:"wrap"
      }}>
        <div style={{
          display:"flex",alignItems:"center",gap:6,background:"#f8fafc",
          border:"1px solid #e2e8f0",borderRadius:6,padding:"5px 10px",minWidth:180
        }}>
          <span style={{color:"#94a3b8",fontSize:13}}>🔍</span>
          <input value={search} onChange={e=>setSearch(e.target.value)}
            placeholder="Tìm kiếm..."
            style={{border:"none",outline:"none",background:"transparent",fontSize:12,color:"#374151",width:140}}/>
        </div>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {types.map(t=>(
            <button key={t} onClick={()=>setFilterType(t)} style={{
              padding:"4px 10px",border:"none",borderRadius:12,cursor:"pointer",fontSize:11,fontWeight:500,
              background:filterType===t?"#2563eb":"#f1f5f9",
              color:filterType===t?"white":"#64748b",transition:"all .15s"
            }}>{t}</button>
          ))}
        </div>
        <button onClick={()=>setAlarmOnly(p=>!p)} style={{
          padding:"4px 10px",border:`1px solid ${alarmOnly?"#ef4444":"#e2e8f0"}`,
          borderRadius:12,cursor:"pointer",fontSize:11,fontWeight:500,
          background:alarmOnly?"#fee2e2":"white",
          color:alarmOnly?"#ef4444":"#64748b",transition:"all .15s"
        }}>⚠ Chỉ cảnh báo</button>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#94a3b8"}}>{filtered.length} thiết bị</span>
        <div style={{display:"flex",gap:2}}>
          {["table","grid"].map(m=>(
            <button key={m} onClick={()=>setViewMode(m)} style={{
              padding:"5px 8px",border:"none",borderRadius:5,cursor:"pointer",
              background:viewMode===m?"#2563eb":"#f1f5f9",
              color:viewMode===m?"white":"#64748b",fontSize:13,transition:"all .15s"
            }}>{m==="table"?"≡":"⊞"}</button>
          ))}
        </div>
      </div>

      {/* Content + detail — identical structure to PXLGPanel */}
      <div style={{flex:1,display:"flex",overflow:"hidden"}}>

        <div style={{flex:1,overflow:"auto"}}>
          {viewMode==="table" ? (
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead>
                <tr style={{background:"#f8fafc",borderBottom:"2px solid #e2e8f0"}}>
                  {["ID","Tên thiết bị","Loại","SL","Ngày SD","Trạng thái","Cảnh báo"].map(h=>(
                    <th key={h} style={{padding:"8px 12px",textAlign:"left",fontWeight:600,
                      color:"#64748b",fontSize:11,whiteSpace:"nowrap"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(item=>{
                  const ss = STATUS_STYLES[item.status]||STATUS_STYLES.ok
                  const isSel = selectedItem?.id===item.id
                  return (
                    <tr key={item.id} onClick={()=>setSelectedItem(p=>p?.id===item.id?null:item)}
                      style={{
                        background:isSel?"#eff6ff":item.alarm?"#fff7f7":"white",
                        borderBottom:"1px solid #f1f5f9",cursor:"pointer",transition:"background .1s"
                      }}>
                      <td style={{padding:"8px 12px",fontFamily:"monospace",color:"#64748b",fontSize:11}}>{item.id}</td>
                      <td style={{padding:"8px 12px",fontWeight:600,color:"#0f172a",maxWidth:260}}>{item.name}</td>
                      <td style={{padding:"8px 12px",color:"#64748b",whiteSpace:"nowrap"}}>{item.type}</td>
                      <td style={{padding:"8px 12px",textAlign:"center",fontWeight:700,color:"#374151"}}>{item.qty}</td>
                      <td style={{padding:"8px 12px",color:"#64748b",whiteSpace:"nowrap",fontSize:11}}>{item.since}</td>
                      <td style={{padding:"8px 12px"}}>
                        <span style={{background:ss.bg,color:ss.color,padding:"2px 8px",
                          borderRadius:8,fontSize:10,fontWeight:600}}>{ss.label}</span>
                      </td>
                      <td style={{padding:"8px 12px",textAlign:"center"}}>
                        {item.alarm
                          ? <span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",
                              display:"inline-flex",alignItems:"center",justifyContent:"center",
                              fontSize:9,color:"white",fontWeight:900}}>!</span>
                          : <span style={{color:"#22c55e",fontSize:14}}>✓</span>}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          ) : (
            <div style={{
              display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",
              gap:10,padding:14
            }}>
              {filtered.map(item=>{
                const ss = STATUS_STYLES[item.status]||STATUS_STYLES.ok
                const isSel = selectedItem?.id===item.id
                return (
                  <div key={item.id} onClick={()=>setSelectedItem(p=>p?.id===item.id?null:item)}
                    style={{
                      background:"white",borderRadius:8,padding:12,cursor:"pointer",
                      border:`2px solid ${isSel?"#2563eb":item.alarm?"#fca5a5":"#e2e8f0"}`,
                      boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.12)":"0 1px 3px rgba(0,0,0,0.04)",
                      transition:"all .15s"
                    }}>
                    <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8",marginBottom:4}}>{item.id}</div>
                    <div style={{fontSize:11,fontWeight:700,color:"#374151",marginBottom:8,lineHeight:1.3}}>{item.name}</div>
                    <div style={{fontSize:20,fontWeight:800,color:"#374151",lineHeight:1}}>{item.qty}
                      <span style={{fontSize:11,color:"#94a3b8",fontWeight:400}}> chiếc</span>
                    </div>
                    <div style={{fontSize:9,color:"#94a3b8",marginBottom:8}}>Sử dụng từ {item.since}</div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span style={{background:ss.bg,color:ss.color,padding:"2px 7px",
                        borderRadius:8,fontSize:9,fontWeight:600}}>{ss.label}</span>
                      {item.alarm&&<span style={{width:16,height:16,borderRadius:"50%",background:"#ef4444",
                        display:"inline-flex",alignItems:"center",justifyContent:"center",
                        fontSize:8,color:"white",fontWeight:900}}>!</span>}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>

        {/* Detail panel — identical to PXLGPanel */}
        <div style={{
          width:268,background:"white",borderLeft:"1px solid #e2e8f0",
          flexShrink:0,overflowY:"auto"
        }}>
          {!selectedItem ? (
            <div style={{height:"100%",display:"flex",flexDirection:"column",
              alignItems:"center",justifyContent:"center",
              color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8}}>
              <span style={{fontSize:32}}>⚙</span>
              <span style={{fontWeight:600,color:"#64748b"}}>Chưa chọn đối tượng</span>
              <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
                Nhấp vào một thiết bị để hiển thị thông tin
              </span>
            </div>
          ) : (()=>{
            const item = selectedItem
            const ss = STATUS_STYLES[item.status]||STATUS_STYLES.ok
            const trend = Array.from({length:20},(_,i)=>
              20+Math.abs(Math.sin(i/3))*60+(Math.random()-.5)*10
            )
            return (
              <div>
                <div style={{padding:"10px 14px",background:"#f8fafc",
                  borderBottom:"1px solid #e2e8f0",
                  display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <div>
                    <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{item.id} · </span>
                    <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{item.name}</span>
                  </div>
                  {item.alarm&&<span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",
                    display:"inline-flex",alignItems:"center",justifyContent:"center",
                    fontSize:9,color:"white",fontWeight:900}}>!</span>}
                </div>
                <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
                  {["Thông tin","Lịch sử","Cảnh báo"].map((t,i)=>(
                    <button key={t} style={{padding:"8px 10px",border:"none",cursor:"pointer",fontSize:11,
                      fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
                      borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",
                      background:"none"}}>{t}</button>
                  ))}
                </div>
                <div style={{padding:"14px",display:"flex",alignItems:"center",
                  gap:10,background:"white",borderBottom:"1px solid #f1f5f9"}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:24,fontWeight:800,color:"#374151",lineHeight:1}}>
                      {item.qty} <span style={{fontSize:13,fontWeight:400,color:"#94a3b8"}}>chiếc</span>
                    </div>
                    <div style={{fontSize:11,color:"#94a3b8",marginTop:2}}>Sử dụng từ {item.since}</div>
                  </div>
                  <span style={{background:ss.bg,color:ss.color,padding:"3px 10px",
                    borderRadius:10,fontSize:10,fontWeight:600}}>{ss.label}</span>
                </div>
                {[
                  ["Mã máy",     item.id],
                  ["Loại",       item.type],
                  ["Số lượng",   `${item.qty} chiếc`],
                  ["Ngày SD",    item.since],
                  ["Trạng thái", ss.label],
                  ["Cảnh báo",   item.alarm?"Có":"Không"],
                ].map(([k,v])=>(
                  <div key={k} style={{display:"flex",justifyContent:"space-between",
                    padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
                    <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
                    <span style={{fontSize:11,fontWeight:600,
                      color:k==="Cảnh báo"&&item.alarm?"#ef4444":"#0f172a"}}>{v}</span>
                  </div>
                ))}
                <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
                  color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>GIỜ VỪA QUA</div>
                <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
                  <div style={{display:"flex",alignItems:"flex-end",gap:1,height:52}}>
                    {trend.map((v,i)=>(
                      <div key={i} style={{flex:1,height:`${v}%`,
                        background:item.alarm?"#ef4444":"#22c55e",
                        borderRadius:"1px 1px 0 0",opacity:0.8}}/>
                    ))}
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",marginTop:3}}>
                    <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
                    <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
                  </div>
                </div>
              </div>
            )
          })()}
        </div>
      </div>
      </>
      )}
    </div>
  )
}



export default PXLTPanel
